[
  {
    "code": "JP-01-11",
    "name": "Abashiri"
  },
  {
    "code": "JP-12-20",
    "name": "Abiko"
  },
  {
    "code": "JP-01-142",
    "name": "Abira"
  },
  {
    "code": "JP-35-19",
    "name": "Abu"
  },
  {
    "code": "JP-20-43",
    "name": "Achi"
  },
  {
    "code": "JP-13-21",
    "name": "Adachi City"
  },
  {
    "code": "JP-15-24",
    "name": "Aga"
  },
  {
    "code": "JP-15-16",
    "name": "Agano"
  },
  {
    "code": "JP-20-53",
    "name": "Agematsu"
  },
  {
    "code": "JP-11-17",
    "name": "Ageo"
  },
  {
    "code": "JP-23-46",
    "name": "Agui"
  },
  {
    "code": "JP-47-31",
    "name": "Aguni"
  },
  {
    "code": "JP-01-91",
    "name": "Aibetsu"
  },
  {
    "code": "JP-14-32",
    "name": "Aikawa"
  },
  {
    "code": "JP-38-20",
    "name": "Ainan"
  },
  {
    "code": "JP-28-09",
    "name": "Aioi"
  },
  {
    "code": "JP-46-19",
    "name": "Aira"
  },
  {
    "code": "JP-23-32",
    "name": "Aisai"
  },
  {
    "code": "JP-25-16",
    "name": "Aisho"
  },
  {
    "code": "JP-07-28",
    "name": "Aizubange"
  },
  {
    "code": "JP-36-20",
    "name": "Aizumi"
  },
  {
    "code": "JP-07-34",
    "name": "Aizumisato"
  },
  {
    "code": "JP-07-02",
    "name": "Aizuwakamatsu"
  },
  {
    "code": "JP-02-15",
    "name": "Ajigasawa"
  },
  {
    "code": "JP-40-54",
    "name": "Aka"
  },
  {
    "code": "JP-01-18",
    "name": "Akabira"
  },
  {
    "code": "JP-01-72",
    "name": "Akaigawa"
  },
  {
    "code": "JP-33-12",
    "name": "Akaiwa"
  },
  {
    "code": "JP-28-04",
    "name": "Akashi"
  },
  {
    "code": "JP-39-03",
    "name": "Aki"
  },
  {
    "code": "JP-34-19",
    "name": "Akiota"
  },
  {
    "code": "JP-13-48",
    "name": "Akiruno"
  },
  {
    "code": "JP-13-30",
    "name": "Akishima"
  },
  {
    "code": "JP-05-01",
    "name": "Akita"
  },
  {
    "code": "JP-34-13",
    "name": "Akitakata"
  },
  {
    "code": "JP-01-170",
    "name": "Akkeshi"
  },
  {
    "code": "JP-28-12",
    "name": "Ako"
  },
  {
    "code": "JP-46-04",
    "name": "Akune"
  },
  {
    "code": "JP-32-16",
    "name": "Ama"
  },
  {
    "code": "JP-23-37",
    "name": "Ama"
  },
  {
    "code": "JP-28-03",
    "name": "Amagasaki"
  },
  {
    "code": "JP-46-39",
    "name": "Amagi"
  },
  {
    "code": "JP-43-13",
    "name": "Amakusa"
  },
  {
    "code": "JP-46-16",
    "name": "Amami"
  },
  {
    "code": "JP-08-39",
    "name": "Ami"
  },
  {
    "code": "JP-21-29",
    "name": "Ampachi"
  },
  {
    "code": "JP-17-18",
    "name": "Anamizu"
  },
  {
    "code": "JP-36-04",
    "name": "Anan"
  },
  {
    "code": "JP-20-42",
    "name": "Anan"
  },
  {
    "code": "JP-29-17",
    "name": "Ando"
  },
  {
    "code": "JP-23-13",
    "name": "Anjo"
  },
  {
    "code": "JP-10-11",
    "name": "Annaka"
  },
  {
    "code": "JP-13-61",
    "name": "Aogashima"
  },
  {
    "code": "JP-20-29",
    "name": "Aoki"
  },
  {
    "code": "JP-02-01",
    "name": "Aomori"
  },
  {
    "code": "JP-13-18",
    "name": "Arakawa City"
  },
  {
    "code": "JP-43-04",
    "name": "Arao"
  },
  {
    "code": "JP-30-04",
    "name": "Arida"
  },
  {
    "code": "JP-30-16",
    "name": "Aridagawa"
  },
  {
    "code": "JP-41-16",
    "name": "Arita"
  },
  {
    "code": "JP-43-44",
    "name": "Asagiri"
  },
  {
    "code": "JP-28-25",
    "name": "Asago"
  },
  {
    "code": "JP-12-13",
    "name": "Asahi"
  },
  {
    "code": "JP-24-18",
    "name": "Asahi"
  },
  {
    "code": "JP-16-15",
    "name": "Asahi"
  },
  {
    "code": "JP-20-62",
    "name": "Asahi"
  },
  {
    "code": "JP-06-18",
    "name": "Asahi"
  },
  {
    "code": "JP-01-04",
    "name": "Asahikawa"
  },
  {
    "code": "JP-11-23",
    "name": "Asaka"
  },
  {
    "code": "JP-07-46",
    "name": "Asakawa"
  },
  {
    "code": "JP-33-15",
    "name": "Asakuchi"
  },
  {
    "code": "JP-40-26",
    "name": "Asakura"
  },
  {
    "code": "JP-01-16",
    "name": "Ashibetsu"
  },
  {
    "code": "JP-09-02",
    "name": "Ashikaga"
  },
  {
    "code": "JP-43-34",
    "name": "Ashikita"
  },
  {
    "code": "JP-28-07",
    "name": "Ashiya"
  },
  {
    "code": "JP-40-37",
    "name": "Ashiya"
  },
  {
    "code": "JP-01-166",
    "name": "Ashoro"
  },
  {
    "code": "JP-43-12",
    "name": "Aso"
  },
  {
    "code": "JP-01-49",
    "name": "Assabu"
  },
  {
    "code": "JP-29-24",
    "name": "Asuka"
  },
  {
    "code": "JP-22-04",
    "name": "Atami"
  },
  {
    "code": "JP-14-13",
    "name": "Atsugi"
  },
  {
    "code": "JP-01-140",
    "name": "Atsuma"
  },
  {
    "code": "JP-36-06",
    "name": "Awa"
  },
  {
    "code": "JP-28-26",
    "name": "Awaji"
  },
  {
    "code": "JP-18-07",
    "name": "Awara"
  },
  {
    "code": "JP-15-30",
    "name": "Awashimaura"
  },
  {
    "code": "JP-45-13",
    "name": "Aya"
  },
  {
    "code": "JP-26-04",
    "name": "Ayabe"
  },
  {
    "code": "JP-37-14",
    "name": "Ayagawa"
  },
  {
    "code": "JP-14-19",
    "name": "Ayase"
  },
  {
    "code": "JP-20-19",
    "name": "Azumino"
  },
  {
    "code": "JP-07-26",
    "name": "Bandai"
  },
  {
    "code": "JP-08-24",
    "name": "Bando"
  },
  {
    "code": "JP-44-02",
    "name": "Beppu"
  },
  {
    "code": "JP-01-176",
    "name": "Betsukai"
  },
  {
    "code": "JP-01-15",
    "name": "Bibai"
  },
  {
    "code": "JP-01-94",
    "name": "Biei"
  },
  {
    "code": "JP-01-102",
    "name": "Bifuka"
  },
  {
    "code": "JP-01-122",
    "name": "Bihoro"
  },
  {
    "code": "JP-01-145",
    "name": "Biratori"
  },
  {
    "code": "JP-33-10",
    "name": "Bizen"
  },
  {
    "code": "JP-44-12",
    "name": "Bungoono"
  },
  {
    "code": "JP-44-09",
    "name": "Bungotakada"
  },
  {
    "code": "JP-13-05",
    "name": "Bunkyo City"
  },
  {
    "code": "JP-40-13",
    "name": "Buzen"
  },
  {
    "code": "JP-47-23",
    "name": "Chatan"
  },
  {
    "code": "JP-12-01",
    "name": "Chiba"
  },
  {
    "code": "JP-32-18",
    "name": "Chibu"
  },
  {
    "code": "JP-11-06",
    "name": "Chichibu"
  },
  {
    "code": "JP-14-09",
    "name": "Chigasaki"
  },
  {
    "code": "JP-27-43",
    "name": "Chihayaakasaka"
  },
  {
    "code": "JP-40-10",
    "name": "Chikugo"
  },
  {
    "code": "JP-20-63",
    "name": "Chikuhoku"
  },
  {
    "code": "JP-40-60",
    "name": "Chikujo"
  },
  {
    "code": "JP-20-17",
    "name": "Chikuma"
  },
  {
    "code": "JP-08-23",
    "name": "Chikusei"
  },
  {
    "code": "JP-40-16",
    "name": "Chikushino"
  },
  {
    "code": "JP-40-44",
    "name": "Chikuzen"
  },
  {
    "code": "JP-46-42",
    "name": "China"
  },
  {
    "code": "JP-20-14",
    "name": "Chino"
  },
  {
    "code": "JP-01-83",
    "name": "Chippubetsu"
  },
  {
    "code": "JP-23-25",
    "name": "Chiryu"
  },
  {
    "code": "JP-23-24",
    "name": "Chita"
  },
  {
    "code": "JP-01-24",
    "name": "Chitose"
  },
  {
    "code": "JP-10-33",
    "name": "Chiyoda"
  },
  {
    "code": "JP-13-01",
    "name": "Chiyoda City"
  },
  {
    "code": "JP-31-07",
    "name": "Chizu"
  },
  {
    "code": "JP-13-31",
    "name": "Chofu"
  },
  {
    "code": "JP-12-51",
    "name": "Chonan"
  },
  {
    "code": "JP-12-48",
    "name": "Chosei"
  },
  {
    "code": "JP-12-02",
    "name": "Choshi"
  },
  {
    "code": "JP-19-13",
    "name": "Chuo"
  },
  {
    "code": "JP-13-02",
    "name": "Chuo City"
  },
  {
    "code": "JP-08-37",
    "name": "Daigo"
  },
  {
    "code": "JP-05-10",
    "name": "Daisen"
  },
  {
    "code": "JP-31-14",
    "name": "Daisen"
  },
  {
    "code": "JP-27-19",
    "name": "Daito"
  },
  {
    "code": "JP-01-32",
    "name": "Date"
  },
  {
    "code": "JP-07-12",
    "name": "Date"
  },
  {
    "code": "JP-40-20",
    "name": "Dazaifu"
  },
  {
    "code": "JP-19-20",
    "name": "Doshi"
  },
  {
    "code": "JP-01-17",
    "name": "Ebetsu"
  },
  {
    "code": "JP-14-16",
    "name": "Ebina"
  },
  {
    "code": "JP-45-09",
    "name": "Ebino"
  },
  {
    "code": "JP-18-08",
    "name": "Echizen"
  },
  {
    "code": "JP-18-13",
    "name": "Echizen"
  },
  {
    "code": "JP-13-23",
    "name": "Edogawa City"
  },
  {
    "code": "JP-18-10",
    "name": "Eiheiji"
  },
  {
    "code": "JP-01-111",
    "name": "Embetsu"
  },
  {
    "code": "JP-21-10",
    "name": "Ena"
  },
  {
    "code": "JP-01-130",
    "name": "Engaru"
  },
  {
    "code": "JP-01-31",
    "name": "Eniwa"
  },
  {
    "code": "JP-01-149",
    "name": "Erimo"
  },
  {
    "code": "JP-01-47",
    "name": "Esashi"
  },
  {
    "code": "JP-01-116",
    "name": "Esashi"
  },
  {
    "code": "JP-34-14",
    "name": "Etajima"
  },
  {
    "code": "JP-13-29",
    "name": "Fuchu"
  },
  {
    "code": "JP-34-07",
    "name": "Fuchu"
  },
  {
    "code": "JP-34-15",
    "name": "Fuchu"
  },
  {
    "code": "JP-03-28",
    "name": "Fudai"
  },
  {
    "code": "JP-19-10",
    "name": "Fuefuki"
  },
  {
    "code": "JP-22-09",
    "name": "Fuji"
  },
  {
    "code": "JP-22-13",
    "name": "Fujieda"
  },
  {
    "code": "JP-27-27",
    "name": "Fujiidera"
  },
  {
    "code": "JP-19-18",
    "name": "Fujikawa"
  },
  {
    "code": "JP-19-25",
    "name": "Fujikawaguchiko"
  },
  {
    "code": "JP-20-32",
    "name": "Fujimi"
  },
  {
    "code": "JP-11-31",
    "name": "Fujimi"
  },
  {
    "code": "JP-11-39",
    "name": "Fujimino"
  },
  {
    "code": "JP-22-06",
    "name": "Fujinomiya"
  },
  {
    "code": "JP-10-09",
    "name": "Fujioka"
  },
  {
    "code": "JP-02-18",
    "name": "Fujisaki"
  },
  {
    "code": "JP-05-16",
    "name": "Fujisato"
  },
  {
    "code": "JP-14-07",
    "name": "Fujisawa"
  },
  {
    "code": "JP-19-02",
    "name": "Fujiyoshida"
  },
  {
    "code": "JP-01-28",
    "name": "Fukagawa"
  },
  {
    "code": "JP-02-16",
    "name": "Fukaura"
  },
  {
    "code": "JP-11-16",
    "name": "Fukaya"
  },
  {
    "code": "JP-40-55",
    "name": "Fukuchi"
  },
  {
    "code": "JP-26-02",
    "name": "Fukuchiyama"
  },
  {
    "code": "JP-18-01",
    "name": "Fukui"
  },
  {
    "code": "JP-40-02",
    "name": "Fukuoka"
  },
  {
    "code": "JP-22-15",
    "name": "Fukuroi"
  },
  {
    "code": "JP-28-35",
    "name": "Fukusaki"
  },
  {
    "code": "JP-01-39",
    "name": "Fukushima"
  },
  {
    "code": "JP-07-01",
    "name": "Fukushima"
  },
  {
    "code": "JP-40-22",
    "name": "Fukutsu"
  },
  {
    "code": "JP-34-06",
    "name": "Fukuyama"
  },
  {
    "code": "JP-12-04",
    "name": "Funabashi"
  },
  {
    "code": "JP-06-23",
    "name": "Funagata"
  },
  {
    "code": "JP-16-11",
    "name": "Funahashi"
  },
  {
    "code": "JP-01-29",
    "name": "Furano"
  },
  {
    "code": "JP-01-69",
    "name": "Furubira"
  },
  {
    "code": "JP-07-47",
    "name": "Furudono"
  },
  {
    "code": "JP-23-42",
    "name": "Fuso"
  },
  {
    "code": "JP-13-39",
    "name": "Fussa"
  },
  {
    "code": "JP-07-55",
    "name": "Futaba"
  },
  {
    "code": "JP-12-24",
    "name": "Futtsu"
  },
  {
    "code": "JP-23-15",
    "name": "Gamagori"
  },
  {
    "code": "JP-39-18",
    "name": "Geisei"
  },
  {
    "code": "JP-41-15",
    "name": "Genkai"
  },
  {
    "code": "JP-21-20",
    "name": "Gero"
  },
  {
    "code": "JP-21-01",
    "name": "Gifu"
  },
  {
    "code": "JP-21-22",
    "name": "Ginan"
  },
  {
    "code": "JP-47-02",
    "name": "Ginowan"
  },
  {
    "code": "JP-47-18",
    "name": "Ginoza"
  },
  {
    "code": "JP-30-05",
    "name": "Gobo"
  },
  {
    "code": "JP-21-27",
    "name": "Godo"
  },
  {
    "code": "JP-29-07",
    "name": "Gojo"
  },
  {
    "code": "JP-05-19",
    "name": "Gojome"
  },
  {
    "code": "JP-08-42",
    "name": "Goka"
  },
  {
    "code": "JP-45-26",
    "name": "Gokase"
  },
  {
    "code": "JP-02-36",
    "name": "Gonohe"
  },
  {
    "code": "JP-29-08",
    "name": "Gose"
  },
  {
    "code": "JP-15-14",
    "name": "Gosen"
  },
  {
    "code": "JP-02-05",
    "name": "Goshogawara"
  },
  {
    "code": "JP-22-14",
    "name": "Gotemba"
  },
  {
    "code": "JP-42-10",
    "name": "Goto"
  },
  {
    "code": "JP-32-07",
    "name": "Gotsu"
  },
  {
    "code": "JP-21-19",
    "name": "Gujo"
  },
  {
    "code": "JP-11-05",
    "name": "Gyoda"
  },
  {
    "code": "JP-43-16",
    "name": "Gyokuto"
  },
  {
    "code": "JP-27-23",
    "name": "Habikino"
  },
  {
    "code": "JP-01-109",
    "name": "Haboro"
  },
  {
    "code": "JP-13-60",
    "name": "Hachijo"
  },
  {
    "code": "JP-03-12",
    "name": "Hachimantai"
  },
  {
    "code": "JP-02-03",
    "name": "Hachinohe"
  },
  {
    "code": "JP-13-24",
    "name": "Hachioji"
  },
  {
    "code": "JP-05-20",
    "name": "Hachirogata"
  },
  {
    "code": "JP-14-12",
    "name": "Hadano"
  },
  {
    "code": "JP-47-28",
    "name": "Haebaru"
  },
  {
    "code": "JP-09-19",
    "name": "Haga"
  },
  {
    "code": "JP-35-04",
    "name": "Hagi"
  },
  {
    "code": "JP-01-02",
    "name": "Hakodate"
  },
  {
    "code": "JP-14-29",
    "name": "Hakone"
  },
  {
    "code": "JP-20-66",
    "name": "Hakuba"
  },
  {
    "code": "JP-17-07",
    "name": "Hakui"
  },
  {
    "code": "JP-17-09",
    "name": "Hakusan"
  },
  {
    "code": "JP-32-02",
    "name": "Hamada"
  },
  {
    "code": "JP-22-02",
    "name": "Hamamatsu"
  },
  {
    "code": "JP-01-171",
    "name": "Hamanaka"
  },
  {
    "code": "JP-01-114",
    "name": "Hamatombetsu"
  },
  {
    "code": "JP-13-47",
    "name": "Hamura"
  },
  {
    "code": "JP-03-04",
    "name": "Hanamaki"
  },
  {
    "code": "JP-07-41",
    "name": "Hanawa"
  },
  {
    "code": "JP-23-06",
    "name": "Handa"
  },
  {
    "code": "JP-27-33",
    "name": "Hannan"
  },
  {
    "code": "JP-11-08",
    "name": "Hanno"
  },
  {
    "code": "JP-11-14",
    "name": "Hanyu"
  },
  {
    "code": "JP-05-18",
    "name": "Happo"
  },
  {
    "code": "JP-20-33",
    "name": "Hara"
  },
  {
    "code": "JP-28-33",
    "name": "Harima"
  },
  {
    "code": "JP-42-18",
    "name": "Hasami"
  },
  {
    "code": "JP-02-39",
    "name": "Hashikami"
  },
  {
    "code": "JP-21-09",
    "name": "Hashima"
  },
  {
    "code": "JP-30-03",
    "name": "Hashimoto"
  },
  {
    "code": "JP-11-33",
    "name": "Hasuda"
  },
  {
    "code": "JP-11-49",
    "name": "Hatoyama"
  },
  {
    "code": "JP-34-12",
    "name": "Hatsukaichi"
  },
  {
    "code": "JP-19-15",
    "name": "Hayakawa"
  },
  {
    "code": "JP-14-20",
    "name": "Hayama"
  },
  {
    "code": "JP-33-17",
    "name": "Hayashima"
  },
  {
    "code": "JP-29-14",
    "name": "Heguri"
  },
  {
    "code": "JP-23-10",
    "name": "Hekinan"
  },
  {
    "code": "JP-21-37",
    "name": "Hichiso"
  },
  {
    "code": "JP-21-17",
    "name": "Hida"
  },
  {
    "code": "JP-01-144",
    "name": "Hidaka"
  },
  {
    "code": "JP-39-29",
    "name": "Hidaka"
  },
  {
    "code": "JP-11-37",
    "name": "Hidaka"
  },
  {
    "code": "JP-30-18",
    "name": "Hidaka"
  },
  {
    "code": "JP-30-22",
    "name": "Hidakagawa"
  },
  {
    "code": "JP-31-13",
    "name": "Hiezu"
  },
  {
    "code": "JP-47-14",
    "name": "Higashi"
  },
  {
    "code": "JP-10-25",
    "name": "Higashiagatsuma"
  },
  {
    "code": "JP-11-55",
    "name": "Higashichichibu"
  },
  {
    "code": "JP-02-32",
    "name": "Higashidori"
  },
  {
    "code": "JP-34-11",
    "name": "Higashihiroshima"
  },
  {
    "code": "JP-22-24",
    "name": "Higashiizu"
  },
  {
    "code": "JP-37-07",
    "name": "Higashikagawa"
  },
  {
    "code": "JP-01-88",
    "name": "Higashikagura"
  },
  {
    "code": "JP-01-93",
    "name": "Higashikawa"
  },
  {
    "code": "JP-13-43",
    "name": "Higashikurume"
  },
  {
    "code": "JP-46-26",
    "name": "Higashikushira"
  },
  {
    "code": "JP-04-12",
    "name": "Higashimatsushima"
  },
  {
    "code": "JP-11-11",
    "name": "Higashimatsuyama"
  },
  {
    "code": "JP-36-24",
    "name": "Higashimiyoshi"
  },
  {
    "code": "JP-13-36",
    "name": "Higashimurayama"
  },
  {
    "code": "JP-05-25",
    "name": "Higashinaruse"
  },
  {
    "code": "JP-06-11",
    "name": "Higashine"
  },
  {
    "code": "JP-25-12",
    "name": "Higashiomi"
  },
  {
    "code": "JP-27-28",
    "name": "Higashiosaka"
  },
  {
    "code": "JP-21-40",
    "name": "Higashishirakawa"
  },
  {
    "code": "JP-42-16",
    "name": "Higashisonogi"
  },
  {
    "code": "JP-23-47",
    "name": "Higashiura"
  },
  {
    "code": "JP-13-41",
    "name": "Higashiyamato"
  },
  {
    "code": "JP-29-39",
    "name": "Higashiyoshino"
  },
  {
    "code": "JP-44-16",
    "name": "Hiji"
  },
  {
    "code": "JP-35-08",
    "name": "Hikari"
  },
  {
    "code": "JP-43-33",
    "name": "Hikawa"
  },
  {
    "code": "JP-25-02",
    "name": "Hikone"
  },
  {
    "code": "JP-28-02",
    "name": "Himeji"
  },
  {
    "code": "JP-44-15",
    "name": "Himeshima"
  },
  {
    "code": "JP-16-04",
    "name": "Himi"
  },
  {
    "code": "JP-25-14",
    "name": "Hino"
  },
  {
    "code": "JP-13-35",
    "name": "Hino"
  },
  {
    "code": "JP-31-18",
    "name": "Hino"
  },
  {
    "code": "JP-13-51",
    "name": "Hinode"
  },
  {
    "code": "JP-07-21",
    "name": "Hinoemata"
  },
  {
    "code": "JP-13-52",
    "name": "Hinohara"
  },
  {
    "code": "JP-45-25",
    "name": "Hinokage"
  },
  {
    "code": "JP-46-10",
    "name": "Hioki"
  },
  {
    "code": "JP-42-06",
    "name": "Hirado"
  },
  {
    "code": "JP-03-22",
    "name": "Hiraizumi"
  },
  {
    "code": "JP-27-11",
    "name": "Hirakata"
  },
  {
    "code": "JP-02-10",
    "name": "Hirakawa"
  },
  {
    "code": "JP-02-11",
    "name": "Hiranai"
  },
  {
    "code": "JP-35-18",
    "name": "Hirao"
  },
  {
    "code": "JP-07-45",
    "name": "Hirata"
  },
  {
    "code": "JP-14-05",
    "name": "Hiratsuka"
  },
  {
    "code": "JP-20-44",
    "name": "Hiraya"
  },
  {
    "code": "JP-30-15",
    "name": "Hirogawa"
  },
  {
    "code": "JP-40-48",
    "name": "Hirokawa"
  },
  {
    "code": "JP-07-50",
    "name": "Hirono"
  },
  {
    "code": "JP-03-32",
    "name": "Hirono"
  },
  {
    "code": "JP-01-161",
    "name": "Hiroo"
  },
  {
    "code": "JP-02-02",
    "name": "Hirosaki"
  },
  {
    "code": "JP-34-01",
    "name": "Hiroshima"
  },
  {
    "code": "JP-40-35",
    "name": "Hisayama"
  },
  {
    "code": "JP-44-04",
    "name": "Hita"
  },
  {
    "code": "JP-08-02",
    "name": "Hitachi"
  },
  {
    "code": "JP-08-17",
    "name": "Hitachinaka"
  },
  {
    "code": "JP-08-21",
    "name": "Hitachiomiya"
  },
  {
    "code": "JP-08-10",
    "name": "Hitachiota"
  },
  {
    "code": "JP-43-03",
    "name": "Hitoyoshi"
  },
  {
    "code": "JP-17-16",
    "name": "Hodatsushimizu"
  },
  {
    "code": "JP-35-05",
    "name": "Hofu"
  },
  {
    "code": "JP-31-16",
    "name": "Hoki"
  },
  {
    "code": "JP-08-30",
    "name": "Hokota"
  },
  {
    "code": "JP-31-12",
    "name": "Hokuei"
  },
  {
    "code": "JP-01-85",
    "name": "Hokuryu"
  },
  {
    "code": "JP-01-35",
    "name": "Hokuto"
  },
  {
    "code": "JP-19-08",
    "name": "Hokuto"
  },
  {
    "code": "JP-01-165",
    "name": "Hombetsu"
  },
  {
    "code": "JP-11-10",
    "name": "Honjo"
  },
  {
    "code": "JP-01-105",
    "name": "Horokanai"
  },
  {
    "code": "JP-01-121",
    "name": "Horonobe"
  },
  {
    "code": "JP-45-06",
    "name": "Hyuga"
  },
  {
    "code": "JP-33-06",
    "name": "Ibara"
  },
  {
    "code": "JP-08-33",
    "name": "Ibaraki"
  },
  {
    "code": "JP-27-12",
    "name": "Ibaraki"
  },
  {
    "code": "JP-21-30",
    "name": "Ibigawa"
  },
  {
    "code": "JP-46-06",
    "name": "Ibusuki"
  },
  {
    "code": "JP-12-17",
    "name": "Ichihara"
  },
  {
    "code": "JP-09-18",
    "name": "Ichikai"
  },
  {
    "code": "JP-28-34",
    "name": "Ichikawa"
  },
  {
    "code": "JP-12-03",
    "name": "Ichikawa"
  },
  {
    "code": "JP-19-14",
    "name": "Ichikawamisato"
  },
  {
    "code": "JP-46-13",
    "name": "Ichikikushikino"
  },
  {
    "code": "JP-03-33",
    "name": "Ichinohe"
  },
  {
    "code": "JP-12-46",
    "name": "Ichinomiya"
  },
  {
    "code": "JP-23-04",
    "name": "Ichinomiya"
  },
  {
    "code": "JP-03-08",
    "name": "Ichinoseki"
  },
  {
    "code": "JP-26-18",
    "name": "Ide"
  },
  {
    "code": "JP-47-20",
    "name": "Ie"
  },
  {
    "code": "JP-24-14",
    "name": "Iga"
  },
  {
    "code": "JP-47-35",
    "name": "Iheya"
  },
  {
    "code": "JP-20-05",
    "name": "Iida"
  },
  {
    "code": "JP-06-32",
    "name": "Iide"
  },
  {
    "code": "JP-20-36",
    "name": "Iijima"
  },
  {
    "code": "JP-32-10",
    "name": "Iinan"
  },
  {
    "code": "JP-07-59",
    "name": "Iitate"
  },
  {
    "code": "JP-20-13",
    "name": "Iiyama"
  },
  {
    "code": "JP-40-06",
    "name": "Iizuka"
  },
  {
    "code": "JP-20-76",
    "name": "Iizuna"
  },
  {
    "code": "JP-29-16",
    "name": "Ikaruga"
  },
  {
    "code": "JP-38-17",
    "name": "Ikata"
  },
  {
    "code": "JP-05-21",
    "name": "Ikawa"
  },
  {
    "code": "JP-21-32",
    "name": "Ikeda"
  },
  {
    "code": "JP-01-163",
    "name": "Ikeda"
  },
  {
    "code": "JP-20-64",
    "name": "Ikeda"
  },
  {
    "code": "JP-27-05",
    "name": "Ikeda"
  },
  {
    "code": "JP-18-11",
    "name": "Ikeda"
  },
  {
    "code": "JP-42-09",
    "name": "Iki"
  },
  {
    "code": "JP-29-09",
    "name": "Ikoma"
  },
  {
    "code": "JP-20-60",
    "name": "Ikusaka"
  },
  {
    "code": "JP-38-02",
    "name": "Imabari"
  },
  {
    "code": "JP-02-12",
    "name": "Imabetsu"
  },
  {
    "code": "JP-01-52",
    "name": "Imakane"
  },
  {
    "code": "JP-41-05",
    "name": "Imari"
  },
  {
    "code": "JP-16-10",
    "name": "Imizu"
  },
  {
    "code": "JP-20-09",
    "name": "Ina"
  },
  {
    "code": "JP-11-40",
    "name": "Ina"
  },
  {
    "code": "JP-24-12",
    "name": "Inabe"
  },
  {
    "code": "JP-28-30",
    "name": "Inagawa"
  },
  {
    "code": "JP-13-46",
    "name": "Inagi"
  },
  {
    "code": "JP-02-20",
    "name": "Inakadate"
  },
  {
    "code": "JP-28-32",
    "name": "Inami"
  },
  {
    "code": "JP-30-20",
    "name": "Inami"
  },
  {
    "code": "JP-08-25",
    "name": "Inashiki"
  },
  {
    "code": "JP-07-27",
    "name": "Inawashiro"
  },
  {
    "code": "JP-23-20",
    "name": "Inazawa"
  },
  {
    "code": "JP-26-25",
    "name": "Ine"
  },
  {
    "code": "JP-39-23",
    "name": "Ino"
  },
  {
    "code": "JP-23-16",
    "name": "Inuyama"
  },
  {
    "code": "JP-12-29",
    "name": "Inzai"
  },
  {
    "code": "JP-11-22",
    "name": "Iruma"
  },
  {
    "code": "JP-46-18",
    "name": "Isa"
  },
  {
    "code": "JP-42-04",
    "name": "Isahaya"
  },
  {
    "code": "JP-24-03",
    "name": "Ise"
  },
  {
    "code": "JP-14-15",
    "name": "Isehara"
  },
  {
    "code": "JP-46-40",
    "name": "Isen"
  },
  {
    "code": "JP-10-04",
    "name": "Isesaki"
  },
  {
    "code": "JP-47-03",
    "name": "Ishigaki"
  },
  {
    "code": "JP-36-12",
    "name": "Ishii"
  },
  {
    "code": "JP-01-34",
    "name": "Ishikari"
  },
  {
    "code": "JP-07-43",
    "name": "Ishikawa"
  },
  {
    "code": "JP-04-02",
    "name": "Ishinomaki"
  },
  {
    "code": "JP-08-05",
    "name": "Ishioka"
  },
  {
    "code": "JP-12-36",
    "name": "Isumi"
  },
  {
    "code": "JP-13-19",
    "name": "Itabashi City"
  },
  {
    "code": "JP-08-19",
    "name": "Itako"
  },
  {
    "code": "JP-10-31",
    "name": "Itakura"
  },
  {
    "code": "JP-28-08",
    "name": "Itami"
  },
  {
    "code": "JP-36-21",
    "name": "Itano"
  },
  {
    "code": "JP-02-21",
    "name": "Itayanagi"
  },
  {
    "code": "JP-22-07",
    "name": "Ito"
  },
  {
    "code": "JP-40-51",
    "name": "Itoda"
  },
  {
    "code": "JP-15-12",
    "name": "Itoigawa"
  },
  {
    "code": "JP-47-06",
    "name": "Itoman"
  },
  {
    "code": "JP-40-28",
    "name": "Itoshima"
  },
  {
    "code": "JP-43-41",
    "name": "Itsuki"
  },
  {
    "code": "JP-30-09",
    "name": "Iwade"
  },
  {
    "code": "JP-03-26",
    "name": "Iwaizumi"
  },
  {
    "code": "JP-07-04",
    "name": "Iwaki"
  },
  {
    "code": "JP-35-07",
    "name": "Iwakuni"
  },
  {
    "code": "JP-23-28",
    "name": "Iwakura"
  },
  {
    "code": "JP-31-05",
    "name": "Iwami"
  },
  {
    "code": "JP-01-10",
    "name": "Iwamizawa"
  },
  {
    "code": "JP-01-65",
    "name": "Iwanai"
  },
  {
    "code": "JP-04-09",
    "name": "Iwanuma"
  },
  {
    "code": "JP-22-10",
    "name": "Iwata"
  },
  {
    "code": "JP-03-16",
    "name": "Iwate"
  },
  {
    "code": "JP-38-08",
    "name": "Iyo"
  },
  {
    "code": "JP-47-36",
    "name": "Izena"
  },
  {
    "code": "JP-22-19",
    "name": "Izu"
  },
  {
    "code": "JP-27-20",
    "name": "Izumi"
  },
  {
    "code": "JP-46-05",
    "name": "Izumi"
  },
  {
    "code": "JP-27-07",
    "name": "Izumiotsu"
  },
  {
    "code": "JP-27-14",
    "name": "Izumisano"
  },
  {
    "code": "JP-07-36",
    "name": "Izumizaki"
  },
  {
    "code": "JP-32-03",
    "name": "Izumo"
  },
  {
    "code": "JP-15-25",
    "name": "Izumozaki"
  },
  {
    "code": "JP-22-22",
    "name": "Izunokuni"
  },
  {
    "code": "JP-34-23",
    "name": "Jinsekikogen"
  },
  {
    "code": "JP-15-15",
    "name": "Joetsu"
  },
  {
    "code": "JP-08-09",
    "name": "Joso"
  },
  {
    "code": "JP-26-08",
    "name": "Joyo"
  },
  {
    "code": "JP-47-22",
    "name": "Kadena"
  },
  {
    "code": "JP-45-20",
    "name": "Kadogawa"
  },
  {
    "code": "JP-27-24",
    "name": "Kadoma"
  },
  {
    "code": "JP-17-06",
    "name": "Kaga"
  },
  {
    "code": "JP-07-18",
    "name": "Kagamiishi"
  },
  {
    "code": "JP-33-21",
    "name": "Kagamino"
  },
  {
    "code": "JP-46-01",
    "name": "Kagoshima"
  },
  {
    "code": "JP-17-08",
    "name": "Kahoku"
  },
  {
    "code": "JP-06-16",
    "name": "Kahoku"
  },
  {
    "code": "JP-19-09",
    "name": "Kai"
  },
  {
    "code": "JP-30-02",
    "name": "Kainan"
  },
  {
    "code": "JP-14-28",
    "name": "Kaisei"
  },
  {
    "code": "JP-34-16",
    "name": "Kaita"
  },
  {
    "code": "JP-36-17",
    "name": "Kaiyo"
  },
  {
    "code": "JP-21-21",
    "name": "Kaizu"
  },
  {
    "code": "JP-27-09",
    "name": "Kaizuka"
  },
  {
    "code": "JP-21-13",
    "name": "Kakamigahara"
  },
  {
    "code": "JP-22-12",
    "name": "Kakegawa"
  },
  {
    "code": "JP-28-11",
    "name": "Kakogawa"
  },
  {
    "code": "JP-04-07",
    "name": "Kakuda"
  },
  {
    "code": "JP-40-25",
    "name": "Kama"
  },
  {
    "code": "JP-12-22",
    "name": "Kamagaya"
  },
  {
    "code": "JP-03-10",
    "name": "Kamaishi"
  },
  {
    "code": "JP-14-06",
    "name": "Kamakura"
  },
  {
    "code": "JP-26-07",
    "name": "Kameoka"
  },
  {
    "code": "JP-24-09",
    "name": "Kameyama"
  },
  {
    "code": "JP-28-40",
    "name": "Kami"
  },
  {
    "code": "JP-04-31",
    "name": "Kami"
  },
  {
    "code": "JP-39-11",
    "name": "Kami"
  },
  {
    "code": "JP-43-10",
    "name": "Kamiamakusa"
  },
  {
    "code": "JP-01-95",
    "name": "Kamifurano"
  },
  {
    "code": "JP-28-38",
    "name": "Kamigori"
  },
  {
    "code": "JP-16-12",
    "name": "Kamiichi"
  },
  {
    "code": "JP-36-22",
    "name": "Kamiita"
  },
  {
    "code": "JP-38-12",
    "name": "Kamijima"
  },
  {
    "code": "JP-36-10",
    "name": "Kamikatsu"
  },
  {
    "code": "JP-01-92",
    "name": "Kamikawa"
  },
  {
    "code": "JP-28-36",
    "name": "Kamikawa"
  },
  {
    "code": "JP-11-57",
    "name": "Kamikawa"
  },
  {
    "code": "JP-29-37",
    "name": "Kamikitayama"
  },
  {
    "code": "JP-05-15",
    "name": "Kamikoani"
  },
  {
    "code": "JP-41-13",
    "name": "Kamimine"
  },
  {
    "code": "JP-09-15",
    "name": "Kaminokawa"
  },
  {
    "code": "JP-01-48",
    "name": "Kaminokuni"
  },
  {
    "code": "JP-35-16",
    "name": "Kaminoseki"
  },
  {
    "code": "JP-06-07",
    "name": "Kaminoyama"
  },
  {
    "code": "JP-11-58",
    "name": "Kamisato"
  },
  {
    "code": "JP-01-153",
    "name": "Kamishihoro"
  },
  {
    "code": "JP-08-28",
    "name": "Kamisu"
  },
  {
    "code": "JP-01-75",
    "name": "Kamisunagawa"
  },
  {
    "code": "JP-30-24",
    "name": "Kamitonda"
  },
  {
    "code": "JP-36-13",
    "name": "Kamiyama"
  },
  {
    "code": "JP-29-25",
    "name": "Kammaki"
  },
  {
    "code": "JP-15-07",
    "name": "Kamo"
  },
  {
    "code": "JP-01-67",
    "name": "Kamoenai"
  },
  {
    "code": "JP-12-21",
    "name": "Kamogawa"
  },
  {
    "code": "JP-27-42",
    "name": "Kanan"
  },
  {
    "code": "JP-17-01",
    "name": "Kanazawa"
  },
  {
    "code": "JP-40-56",
    "name": "Kanda"
  },
  {
    "code": "JP-03-21",
    "name": "Kanegasaki"
  },
  {
    "code": "JP-07-32",
    "name": "Kaneyama"
  },
  {
    "code": "JP-06-21",
    "name": "Kaneyama"
  },
  {
    "code": "JP-21-14",
    "name": "Kani"
  },
  {
    "code": "JP-23-44",
    "name": "Kanie"
  },
  {
    "code": "JP-10-16",
    "name": "Kanna"
  },
  {
    "code": "JP-22-29",
    "name": "Kannami"
  },
  {
    "code": "JP-37-05",
    "name": "Kanonji"
  },
  {
    "code": "JP-46-02",
    "name": "Kanoya"
  },
  {
    "code": "JP-10-19",
    "name": "Kanra"
  },
  {
    "code": "JP-09-05",
    "name": "Kanuma"
  },
  {
    "code": "JP-41-10",
    "name": "Kanzaki"
  },
  {
    "code": "JP-41-02",
    "name": "Karatsu"
  },
  {
    "code": "JP-15-28",
    "name": "Kariwa"
  },
  {
    "code": "JP-23-11",
    "name": "Kariya"
  },
  {
    "code": "JP-20-26",
    "name": "Karuizawa"
  },
  {
    "code": "JP-03-29",
    "name": "Karumai"
  },
  {
    "code": "JP-26-20",
    "name": "Kasagi"
  },
  {
    "code": "JP-28-20",
    "name": "Kasai"
  },
  {
    "code": "JP-08-13",
    "name": "Kasama"
  },
  {
    "code": "JP-21-23",
    "name": "Kasamatsu"
  },
  {
    "code": "JP-33-05",
    "name": "Kasaoka"
  },
  {
    "code": "JP-29-10",
    "name": "Kashiba"
  },
  {
    "code": "JP-29-05",
    "name": "Kashihara"
  },
  {
    "code": "JP-08-18",
    "name": "Kashima"
  },
  {
    "code": "JP-41-07",
    "name": "Kashima"
  },
  {
    "code": "JP-43-29",
    "name": "Kashima"
  },
  {
    "code": "JP-12-15",
    "name": "Kashiwa"
  },
  {
    "code": "JP-27-22",
    "name": "Kashiwara"
  },
  {
    "code": "JP-15-04",
    "name": "Kashiwazaki"
  },
  {
    "code": "JP-40-17",
    "name": "Kasuga"
  },
  {
    "code": "JP-23-07",
    "name": "Kasugai"
  },
  {
    "code": "JP-11-12",
    "name": "Kasukabe"
  },
  {
    "code": "JP-08-26",
    "name": "Kasumigaura"
  },
  {
    "code": "JP-40-36",
    "name": "Kasuya"
  },
  {
    "code": "JP-05-09",
    "name": "Katagami"
  },
  {
    "code": "JP-27-31",
    "name": "Katano"
  },
  {
    "code": "JP-10-26",
    "name": "Katashina"
  },
  {
    "code": "JP-28-28",
    "name": "Kato"
  },
  {
    "code": "JP-12-34",
    "name": "Katori"
  },
  {
    "code": "JP-29-11",
    "name": "Katsuragi"
  },
  {
    "code": "JP-30-11",
    "name": "Katsuragi"
  },
  {
    "code": "JP-07-57",
    "name": "Katsurao"
  },
  {
    "code": "JP-13-22",
    "name": "Katsushika City"
  },
  {
    "code": "JP-12-16",
    "name": "Katsuura"
  },
  {
    "code": "JP-36-09",
    "name": "Katsuura"
  },
  {
    "code": "JP-18-05",
    "name": "Katsuyama"
  },
  {
    "code": "JP-10-27",
    "name": "Kawaba"
  },
  {
    "code": "JP-21-36",
    "name": "Kawabe"
  },
  {
    "code": "JP-08-40",
    "name": "Kawachi"
  },
  {
    "code": "JP-27-17",
    "name": "Kawachinagano"
  },
  {
    "code": "JP-24-19",
    "name": "Kawagoe"
  },
  {
    "code": "JP-11-02",
    "name": "Kawagoe"
  },
  {
    "code": "JP-11-04",
    "name": "Kawaguchi"
  },
  {
    "code": "JP-29-28",
    "name": "Kawai"
  },
  {
    "code": "JP-11-47",
    "name": "Kawajima"
  },
  {
    "code": "JP-20-21",
    "name": "Kawakami"
  },
  {
    "code": "JP-29-38",
    "name": "Kawakami"
  },
  {
    "code": "JP-17-11",
    "name": "Kawakita"
  },
  {
    "code": "JP-07-16",
    "name": "Kawamata"
  },
  {
    "code": "JP-45-18",
    "name": "Kawaminami"
  },
  {
    "code": "JP-32-11",
    "name": "Kawamoto"
  },
  {
    "code": "JP-22-34",
    "name": "Kawanehon"
  },
  {
    "code": "JP-28-17",
    "name": "Kawanishi"
  },
  {
    "code": "JP-06-29",
    "name": "Kawanishi"
  },
  {
    "code": "JP-29-18",
    "name": "Kawanishi"
  },
  {
    "code": "JP-40-49",
    "name": "Kawara"
  },
  {
    "code": "JP-04-19",
    "name": "Kawasaki"
  },
  {
    "code": "JP-40-52",
    "name": "Kawasaki"
  },
  {
    "code": "JP-14-02",
    "name": "Kawasaki"
  },
  {
    "code": "JP-42-17",
    "name": "Kawatana"
  },
  {
    "code": "JP-07-53",
    "name": "Kawauchi"
  },
  {
    "code": "JP-22-25",
    "name": "Kawazu"
  },
  {
    "code": "JP-02-33",
    "name": "Kazamaura"
  },
  {
    "code": "JP-11-09",
    "name": "Kazo"
  },
  {
    "code": "JP-05-07",
    "name": "Kazuno"
  },
  {
    "code": "JP-40-43",
    "name": "Keisen"
  },
  {
    "code": "JP-01-100",
    "name": "Kembuchi"
  },
  {
    "code": "JP-04-04",
    "name": "Kesennuma"
  },
  {
    "code": "JP-33-27",
    "name": "Kibichuo"
  },
  {
    "code": "JP-24-29",
    "name": "Kiho"
  },
  {
    "code": "JP-24-27",
    "name": "Kihoku"
  },
  {
    "code": "JP-38-19",
    "name": "Kihoku"
  },
  {
    "code": "JP-20-72",
    "name": "Kijimadaira"
  },
  {
    "code": "JP-45-17",
    "name": "Kijo"
  },
  {
    "code": "JP-46-37",
    "name": "Kikai"
  },
  {
    "code": "JP-01-41",
    "name": "Kikonai"
  },
  {
    "code": "JP-43-08",
    "name": "Kikuchi"
  },
  {
    "code": "JP-22-21",
    "name": "Kikugawa"
  },
  {
    "code": "JP-43-21",
    "name": "Kikuyo"
  },
  {
    "code": "JP-30-10",
    "name": "Kimino"
  },
  {
    "code": "JP-12-23",
    "name": "Kimitsu"
  },
  {
    "code": "JP-01-61",
    "name": "Kimobetsu"
  },
  {
    "code": "JP-46-29",
    "name": "Kimotsuki"
  },
  {
    "code": "JP-47-19",
    "name": "Kin"
  },
  {
    "code": "JP-46-27",
    "name": "Kinko"
  },
  {
    "code": "JP-30-08",
    "name": "Kinokawa"
  },
  {
    "code": "JP-46-12",
    "name": "Kirishima"
  },
  {
    "code": "JP-10-03",
    "name": "Kiryu"
  },
  {
    "code": "JP-12-06",
    "name": "Kisarazu"
  },
  {
    "code": "JP-27-03",
    "name": "Kishiwada"
  },
  {
    "code": "JP-20-58",
    "name": "Kiso"
  },
  {
    "code": "JP-20-55",
    "name": "Kiso"
  },
  {
    "code": "JP-24-15",
    "name": "Kisosaki"
  },
  {
    "code": "JP-13-17",
    "name": "Kita City"
  },
  {
    "code": "JP-20-24",
    "name": "Kitaaiki"
  },
  {
    "code": "JP-05-11",
    "name": "Kitaakita"
  },
  {
    "code": "JP-47-34",
    "name": "Kitadaito"
  },
  {
    "code": "JP-21-33",
    "name": "Kitagata"
  },
  {
    "code": "JP-39-16",
    "name": "Kitagawa"
  },
  {
    "code": "JP-01-33",
    "name": "Kitahiroshima"
  },
  {
    "code": "JP-34-20",
    "name": "Kitahiroshima"
  },
  {
    "code": "JP-08-12",
    "name": "Kitaibaraki"
  },
  {
    "code": "JP-36-19",
    "name": "Kitajima"
  },
  {
    "code": "JP-03-05",
    "name": "Kitakami"
  },
  {
    "code": "JP-07-07",
    "name": "Kitakata"
  },
  {
    "code": "JP-40-01",
    "name": "Kitakyushu"
  },
  {
    "code": "JP-01-08",
    "name": "Kitami"
  },
  {
    "code": "JP-11-29",
    "name": "Kitamoto"
  },
  {
    "code": "JP-23-34",
    "name": "Kitanagoya"
  },
  {
    "code": "JP-47-24",
    "name": "Kitanakagusuku"
  },
  {
    "code": "JP-07-24",
    "name": "Kitashiobara"
  },
  {
    "code": "JP-30-29",
    "name": "Kitayama"
  },
  {
    "code": "JP-44-10",
    "name": "Kitsuki"
  },
  {
    "code": "JP-41-12",
    "name": "Kiyama"
  },
  {
    "code": "JP-14-33",
    "name": "Kiyokawa"
  },
  {
    "code": "JP-01-125",
    "name": "Kiyosato"
  },
  {
    "code": "JP-13-42",
    "name": "Kiyose"
  },
  {
    "code": "JP-23-33",
    "name": "Kiyosu"
  },
  {
    "code": "JP-26-15",
    "name": "Kizugawa"
  },
  {
    "code": "JP-45-05",
    "name": "Kobayashi"
  },
  {
    "code": "JP-28-01",
    "name": "Kobe"
  },
  {
    "code": "JP-39-01",
    "name": "Kochi"
  },
  {
    "code": "JP-13-34",
    "name": "Kodaira"
  },
  {
    "code": "JP-19-01",
    "name": "Kofu"
  },
  {
    "code": "JP-31-19",
    "name": "Kofu"
  },
  {
    "code": "JP-08-04",
    "name": "Koga"
  },
  {
    "code": "JP-40-21",
    "name": "Koga"
  },
  {
    "code": "JP-13-33",
    "name": "Koganei"
  },
  {
    "code": "JP-40-59",
    "name": "Koge"
  },
  {
    "code": "JP-41-18",
    "name": "Kohoku"
  },
  {
    "code": "JP-25-08",
    "name": "Koka"
  },
  {
    "code": "JP-44-17",
    "name": "Kokonoe"
  },
  {
    "code": "JP-13-37",
    "name": "Kokubunji"
  },
  {
    "code": "JP-13-40",
    "name": "Komae"
  },
  {
    "code": "JP-20-10",
    "name": "Komagane"
  },
  {
    "code": "JP-23-19",
    "name": "Komaki"
  },
  {
    "code": "JP-17-03",
    "name": "Komatsu"
  },
  {
    "code": "JP-36-03",
    "name": "Komatsushima"
  },
  {
    "code": "JP-24-17",
    "name": "Komono"
  },
  {
    "code": "JP-20-08",
    "name": "Komoro"
  },
  {
    "code": "JP-25-10",
    "name": "Konan"
  },
  {
    "code": "JP-39-10",
    "name": "Konan"
  },
  {
    "code": "JP-23-18",
    "name": "Konan"
  },
  {
    "code": "JP-11-15",
    "name": "Konosu"
  },
  {
    "code": "JP-07-14",
    "name": "Koori"
  },
  {
    "code": "JP-25-18",
    "name": "Kora"
  },
  {
    "code": "JP-07-03",
    "name": "Koriyama"
  },
  {
    "code": "JP-29-27",
    "name": "Koryo"
  },
  {
    "code": "JP-43-31",
    "name": "Kosa"
  },
  {
    "code": "JP-22-18",
    "name": "Kosai"
  },
  {
    "code": "JP-05-14",
    "name": "Kosaka"
  },
  {
    "code": "JP-43-14",
    "name": "Koshi"
  },
  {
    "code": "JP-11-19",
    "name": "Koshigaya"
  },
  {
    "code": "JP-01-126",
    "name": "Koshimizu"
  },
  {
    "code": "JP-19-12",
    "name": "Koshu"
  },
  {
    "code": "JP-19-26",
    "name": "Kosuge"
  },
  {
    "code": "JP-23-51",
    "name": "Kota"
  },
  {
    "code": "JP-40-41",
    "name": "Kotake"
  },
  {
    "code": "JP-13-08",
    "name": "Koto City"
  },
  {
    "code": "JP-37-15",
    "name": "Kotohira"
  },
  {
    "code": "JP-31-11",
    "name": "Kotoura"
  },
  {
    "code": "JP-20-20",
    "name": "Koumi"
  },
  {
    "code": "JP-30-13",
    "name": "Koya"
  },
  {
    "code": "JP-30-28",
    "name": "Kozagawa"
  },
  {
    "code": "JP-12-39",
    "name": "Kozaki"
  },
  {
    "code": "JP-13-57",
    "name": "Kozushima"
  },
  {
    "code": "JP-35-06",
    "name": "Kudamatsu"
  },
  {
    "code": "JP-30-12",
    "name": "Kudoyama"
  },
  {
    "code": "JP-03-06",
    "name": "Kuji"
  },
  {
    "code": "JP-12-43",
    "name": "Kujukuri"
  },
  {
    "code": "JP-11-28",
    "name": "Kuki"
  },
  {
    "code": "JP-43-43",
    "name": "Kuma"
  },
  {
    "code": "JP-11-03",
    "name": "Kumagaya"
  },
  {
    "code": "JP-38-13",
    "name": "Kumakogen"
  },
  {
    "code": "JP-43-01",
    "name": "Kumamoto"
  },
  {
    "code": "JP-24-11",
    "name": "Kumano"
  },
  {
    "code": "JP-34-17",
    "name": "Kumano"
  },
  {
    "code": "JP-27-38",
    "name": "Kumatori"
  },
  {
    "code": "JP-47-37",
    "name": "Kumejima"
  },
  {
    "code": "JP-33-25",
    "name": "Kumenan"
  },
  {
    "code": "JP-26-17",
    "name": "Kumiyama"
  },
  {
    "code": "JP-47-12",
    "name": "Kunigami"
  },
  {
    "code": "JP-07-15",
    "name": "Kunimi"
  },
  {
    "code": "JP-44-14",
    "name": "Kunisaki"
  },
  {
    "code": "JP-13-38",
    "name": "Kunitachi"
  },
  {
    "code": "JP-45-12",
    "name": "Kunitomi"
  },
  {
    "code": "JP-01-127",
    "name": "Kunneppu"
  },
  {
    "code": "JP-03-31",
    "name": "Kunohe"
  },
  {
    "code": "JP-33-02",
    "name": "Kurashiki"
  },
  {
    "code": "JP-40-42",
    "name": "Kurate"
  },
  {
    "code": "JP-31-03",
    "name": "Kurayoshi"
  },
  {
    "code": "JP-34-02",
    "name": "Kure"
  },
  {
    "code": "JP-04-11",
    "name": "Kurihara"
  },
  {
    "code": "JP-01-78",
    "name": "Kuriyama"
  },
  {
    "code": "JP-16-06",
    "name": "Kurobe"
  },
  {
    "code": "JP-02-04",
    "name": "Kuroishi"
  },
  {
    "code": "JP-01-56",
    "name": "Kuromatsunai"
  },
  {
    "code": "JP-39-34",
    "name": "Kuroshio"
  },
  {
    "code": "JP-29-32",
    "name": "Kurotaki"
  },
  {
    "code": "JP-40-04",
    "name": "Kurume"
  },
  {
    "code": "JP-25-05",
    "name": "Kusatsu"
  },
  {
    "code": "JP-10-23",
    "name": "Kusatsu"
  },
  {
    "code": "JP-45-07",
    "name": "Kushima"
  },
  {
    "code": "JP-30-30",
    "name": "Kushimoto"
  },
  {
    "code": "JP-01-06",
    "name": "Kushiro"
  },
  {
    "code": "JP-01-169",
    "name": "Kushiro"
  },
  {
    "code": "JP-44-18",
    "name": "Kusu"
  },
  {
    "code": "JP-01-63",
    "name": "Kutchan"
  },
  {
    "code": "JP-24-05",
    "name": "Kuwana"
  },
  {
    "code": "JP-03-15",
    "name": "Kuzumaki"
  },
  {
    "code": "JP-01-62",
    "name": "Kyogoku"
  },
  {
    "code": "JP-12-54",
    "name": "Kyonan"
  },
  {
    "code": "JP-26-24",
    "name": "Kyotamba"
  },
  {
    "code": "JP-26-12",
    "name": "Kyotanabe"
  },
  {
    "code": "JP-26-13",
    "name": "Kyotango"
  },
  {
    "code": "JP-26-01",
    "name": "Kyoto"
  },
  {
    "code": "JP-01-64",
    "name": "Kyowa"
  },
  {
    "code": "JP-13-32",
    "name": "Machida"
  },
  {
    "code": "JP-10-01",
    "name": "Maebashi"
  },
  {
    "code": "JP-25-13",
    "name": "Maibara"
  },
  {
    "code": "JP-26-03",
    "name": "Maizuru"
  },
  {
    "code": "JP-22-23",
    "name": "Makinohara"
  },
  {
    "code": "JP-01-59",
    "name": "Makkari"
  },
  {
    "code": "JP-01-162",
    "name": "Makubetsu"
  },
  {
    "code": "JP-46-03",
    "name": "Makurazaki"
  },
  {
    "code": "JP-06-24",
    "name": "Mamurogawa"
  },
  {
    "code": "JP-14-30",
    "name": "Manazuru"
  },
  {
    "code": "JP-33-13",
    "name": "Maniwa"
  },
  {
    "code": "JP-37-17",
    "name": "Manno"
  },
  {
    "code": "JP-37-02",
    "name": "Marugame"
  },
  {
    "code": "JP-04-20",
    "name": "Marumori"
  },
  {
    "code": "JP-38-14",
    "name": "Masaki"
  },
  {
    "code": "JP-01-106",
    "name": "Mashike"
  },
  {
    "code": "JP-43-30",
    "name": "Mashiki"
  },
  {
    "code": "JP-09-16",
    "name": "Mashiko"
  },
  {
    "code": "JP-32-04",
    "name": "Masuda"
  },
  {
    "code": "JP-27-18",
    "name": "Matsubara"
  },
  {
    "code": "JP-11-63",
    "name": "Matsubushi"
  },
  {
    "code": "JP-14-26",
    "name": "Matsuda"
  },
  {
    "code": "JP-12-07",
    "name": "Matsudo"
  },
  {
    "code": "JP-32-01",
    "name": "Matsue"
  },
  {
    "code": "JP-20-40",
    "name": "Matsukawa"
  },
  {
    "code": "JP-20-65",
    "name": "Matsukawa"
  },
  {
    "code": "JP-01-38",
    "name": "Matsumae"
  },
  {
    "code": "JP-20-02",
    "name": "Matsumoto"
  },
  {
    "code": "JP-38-18",
    "name": "Matsuno"
  },
  {
    "code": "JP-24-04",
    "name": "Matsusaka"
  },
  {
    "code": "JP-36-18",
    "name": "Matsushige"
  },
  {
    "code": "JP-04-23",
    "name": "Matsushima"
  },
  {
    "code": "JP-42-07",
    "name": "Matsuura"
  },
  {
    "code": "JP-38-01",
    "name": "Matsuyama"
  },
  {
    "code": "JP-22-27",
    "name": "Matsuzaki"
  },
  {
    "code": "JP-13-10",
    "name": "Meguro City"
  },
  {
    "code": "JP-24-21",
    "name": "Meiwa"
  },
  {
    "code": "JP-10-32",
    "name": "Meiwa"
  },
  {
    "code": "JP-01-157",
    "name": "Memuro"
  },
  {
    "code": "JP-09-20",
    "name": "Mibu"
  },
  {
    "code": "JP-10-12",
    "name": "Midori"
  },
  {
    "code": "JP-43-28",
    "name": "Mifune"
  },
  {
    "code": "JP-24-28",
    "name": "Mihama"
  },
  {
    "code": "JP-23-49",
    "name": "Mihama"
  },
  {
    "code": "JP-18-14",
    "name": "Mihama"
  },
  {
    "code": "JP-30-17",
    "name": "Mihama"
  },
  {
    "code": "JP-39-33",
    "name": "Mihara"
  },
  {
    "code": "JP-34-04",
    "name": "Mihara"
  },
  {
    "code": "JP-07-48",
    "name": "Miharu"
  },
  {
    "code": "JP-08-38",
    "name": "Miho"
  },
  {
    "code": "JP-01-22",
    "name": "Mikasa"
  },
  {
    "code": "JP-06-33",
    "name": "Mikawa"
  },
  {
    "code": "JP-37-11",
    "name": "Miki"
  },
  {
    "code": "JP-28-15",
    "name": "Miki"
  },
  {
    "code": "JP-13-59",
    "name": "Mikurajima"
  },
  {
    "code": "JP-36-07",
    "name": "Mima"
  },
  {
    "code": "JP-33-14",
    "name": "Mimasaka"
  },
  {
    "code": "JP-45-10",
    "name": "Mimata"
  },
  {
    "code": "JP-30-21",
    "name": "Minabe"
  },
  {
    "code": "JP-10-29",
    "name": "Minakami"
  },
  {
    "code": "JP-43-05",
    "name": "Minamata"
  },
  {
    "code": "JP-36-16",
    "name": "Minami"
  },
  {
    "code": "JP-19-07",
    "name": "Minami-Alps"
  },
  {
    "code": "JP-20-23",
    "name": "Minamiaiki"
  },
  {
    "code": "JP-07-23",
    "name": "Minamiaizu"
  },
  {
    "code": "JP-14-18",
    "name": "Minamiashigara"
  },
  {
    "code": "JP-43-27",
    "name": "Minamiaso"
  },
  {
    "code": "JP-28-24",
    "name": "Minamiawaji"
  },
  {
    "code": "JP-12-32",
    "name": "Minamiboso"
  },
  {
    "code": "JP-23-48",
    "name": "Minamichita"
  },
  {
    "code": "JP-47-33",
    "name": "Minamidaito"
  },
  {
    "code": "JP-18-12",
    "name": "Minamiechizen"
  },
  {
    "code": "JP-01-97",
    "name": "Minamifurano"
  },
  {
    "code": "JP-24-26",
    "name": "Minamiise"
  },
  {
    "code": "JP-22-26",
    "name": "Minamiizu"
  },
  {
    "code": "JP-46-17",
    "name": "Minamikyushu"
  },
  {
    "code": "JP-20-22",
    "name": "Minamimaki"
  },
  {
    "code": "JP-20-37",
    "name": "Minamiminowa"
  },
  {
    "code": "JP-43-22",
    "name": "Minamioguni"
  },
  {
    "code": "JP-46-28",
    "name": "Minamiosumi"
  },
  {
    "code": "JP-04-35",
    "name": "Minamisanriku"
  },
  {
    "code": "JP-46-14",
    "name": "Minamisatsuma"
  },
  {
    "code": "JP-42-13",
    "name": "Minamishimabara"
  },
  {
    "code": "JP-07-11",
    "name": "Minamisoma"
  },
  {
    "code": "JP-46-31",
    "name": "Minamitane"
  },
  {
    "code": "JP-15-19",
    "name": "Minamiuonuma"
  },
  {
    "code": "JP-26-23",
    "name": "Minamiyamashiro"
  },
  {
    "code": "JP-11-52",
    "name": "Minano"
  },
  {
    "code": "JP-13-03",
    "name": "Minato City"
  },
  {
    "code": "JP-35-11",
    "name": "Mine"
  },
  {
    "code": "JP-21-07",
    "name": "Mino"
  },
  {
    "code": "JP-19-16",
    "name": "Minobu"
  },
  {
    "code": "JP-21-11",
    "name": "Minokamo"
  },
  {
    "code": "JP-27-21",
    "name": "Minoo"
  },
  {
    "code": "JP-20-35",
    "name": "Minowa"
  },
  {
    "code": "JP-33-26",
    "name": "Misaki"
  },
  {
    "code": "JP-27-40",
    "name": "Misaki"
  },
  {
    "code": "JP-31-09",
    "name": "Misasa"
  },
  {
    "code": "JP-05-23",
    "name": "Misato"
  },
  {
    "code": "JP-45-23",
    "name": "Misato"
  },
  {
    "code": "JP-04-33",
    "name": "Misato"
  },
  {
    "code": "JP-32-12",
    "name": "Misato"
  },
  {
    "code": "JP-11-56",
    "name": "Misato"
  },
  {
    "code": "JP-43-15",
    "name": "Misato"
  },
  {
    "code": "JP-11-32",
    "name": "Misato"
  },
  {
    "code": "JP-02-07",
    "name": "Misawa"
  },
  {
    "code": "JP-07-31",
    "name": "Mishima"
  },
  {
    "code": "JP-46-20",
    "name": "Mishima"
  },
  {
    "code": "JP-22-05",
    "name": "Mishima"
  },
  {
    "code": "JP-13-27",
    "name": "Mitaka"
  },
  {
    "code": "JP-21-41",
    "name": "Mitake"
  },
  {
    "code": "JP-05-17",
    "name": "Mitane"
  },
  {
    "code": "JP-08-01",
    "name": "Mito"
  },
  {
    "code": "JP-37-08",
    "name": "Mitoyo"
  },
  {
    "code": "JP-29-22",
    "name": "Mitsue"
  },
  {
    "code": "JP-15-09",
    "name": "Mitsuke"
  },
  {
    "code": "JP-14-11",
    "name": "Miura"
  },
  {
    "code": "JP-20-39",
    "name": "Miyada"
  },
  {
    "code": "JP-13-58",
    "name": "Miyake"
  },
  {
    "code": "JP-29-19",
    "name": "Miyake"
  },
  {
    "code": "JP-41-14",
    "name": "Miyaki"
  },
  {
    "code": "JP-40-57",
    "name": "Miyako"
  },
  {
    "code": "JP-03-02",
    "name": "Miyako"
  },
  {
    "code": "JP-47-10",
    "name": "Miyakojima"
  },
  {
    "code": "JP-45-02",
    "name": "Miyakonojo"
  },
  {
    "code": "JP-40-27",
    "name": "Miyama"
  },
  {
    "code": "JP-11-60",
    "name": "Miyashiro"
  },
  {
    "code": "JP-40-24",
    "name": "Miyawaka"
  },
  {
    "code": "JP-45-01",
    "name": "Miyazaki"
  },
  {
    "code": "JP-26-06",
    "name": "Miyazu"
  },
  {
    "code": "JP-36-08",
    "name": "Miyoshi"
  },
  {
    "code": "JP-23-36",
    "name": "Miyoshi"
  },
  {
    "code": "JP-11-41",
    "name": "Miyoshi"
  },
  {
    "code": "JP-34-08",
    "name": "Miyoshi"
  },
  {
    "code": "JP-20-27",
    "name": "Miyota"
  },
  {
    "code": "JP-13-50",
    "name": "Mizuho"
  },
  {
    "code": "JP-21-16",
    "name": "Mizuho"
  },
  {
    "code": "JP-43-39",
    "name": "Mizukami"
  },
  {
    "code": "JP-40-38",
    "name": "Mizumaki"
  },
  {
    "code": "JP-21-08",
    "name": "Mizunami"
  },
  {
    "code": "JP-12-09",
    "name": "Mobara"
  },
  {
    "code": "JP-06-22",
    "name": "Mogami"
  },
  {
    "code": "JP-09-08",
    "name": "Moka"
  },
  {
    "code": "JP-01-19",
    "name": "Mombetsu"
  },
  {
    "code": "JP-01-44",
    "name": "Mori"
  },
  {
    "code": "JP-22-35",
    "name": "Mori"
  },
  {
    "code": "JP-27-10",
    "name": "Moriguchi"
  },
  {
    "code": "JP-03-01",
    "name": "Morioka"
  },
  {
    "code": "JP-08-20",
    "name": "Moriya"
  },
  {
    "code": "JP-25-06",
    "name": "Moriyama"
  },
  {
    "code": "JP-45-21",
    "name": "Morotsuka"
  },
  {
    "code": "JP-11-42",
    "name": "Moroyama"
  },
  {
    "code": "JP-01-82",
    "name": "Moseushi"
  },
  {
    "code": "JP-09-17",
    "name": "Motegi"
  },
  {
    "code": "JP-47-16",
    "name": "Motobu"
  },
  {
    "code": "JP-07-13",
    "name": "Motomiya"
  },
  {
    "code": "JP-21-18",
    "name": "Motosu"
  },
  {
    "code": "JP-39-19",
    "name": "Motoyama"
  },
  {
    "code": "JP-36-15",
    "name": "Mugi"
  },
  {
    "code": "JP-01-143",
    "name": "Mukawa"
  },
  {
    "code": "JP-26-09",
    "name": "Muko"
  },
  {
    "code": "JP-40-19",
    "name": "Munakata"
  },
  {
    "code": "JP-15-10",
    "name": "Murakami"
  },
  {
    "code": "JP-04-17",
    "name": "Murata"
  },
  {
    "code": "JP-06-08",
    "name": "Murayama"
  },
  {
    "code": "JP-01-05",
    "name": "Muroran"
  },
  {
    "code": "JP-39-02",
    "name": "Muroto"
  },
  {
    "code": "JP-13-44",
    "name": "Musashimurayama"
  },
  {
    "code": "JP-13-26",
    "name": "Musashino"
  },
  {
    "code": "JP-02-08",
    "name": "Mutsu"
  },
  {
    "code": "JP-12-47",
    "name": "Mutsuzawa"
  },
  {
    "code": "JP-15-13",
    "name": "Myoko"
  },
  {
    "code": "JP-24-07",
    "name": "Nabari"
  },
  {
    "code": "JP-30-26",
    "name": "Nachikatsuura"
  },
  {
    "code": "JP-25-03",
    "name": "Nagahama"
  },
  {
    "code": "JP-06-09",
    "name": "Nagai"
  },
  {
    "code": "JP-22-31",
    "name": "Nagaizumi"
  },
  {
    "code": "JP-23-39",
    "name": "Nagakute"
  },
  {
    "code": "JP-20-01",
    "name": "Nagano"
  },
  {
    "code": "JP-10-21",
    "name": "Naganohara"
  },
  {
    "code": "JP-01-77",
    "name": "Naganuma"
  },
  {
    "code": "JP-15-02",
    "name": "Nagaoka"
  },
  {
    "code": "JP-26-10",
    "name": "Nagaokakyo"
  },
  {
    "code": "JP-12-50",
    "name": "Nagara"
  },
  {
    "code": "JP-12-18",
    "name": "Nagareyama"
  },
  {
    "code": "JP-42-01",
    "name": "Nagasaki"
  },
  {
    "code": "JP-46-23",
    "name": "Nagashima"
  },
  {
    "code": "JP-43-18",
    "name": "Nagasu"
  },
  {
    "code": "JP-35-09",
    "name": "Nagato"
  },
  {
    "code": "JP-11-53",
    "name": "Nagatoro"
  },
  {
    "code": "JP-20-30",
    "name": "Nagawa"
  },
  {
    "code": "JP-42-14",
    "name": "Nagayo"
  },
  {
    "code": "JP-33-23",
    "name": "Nagi"
  },
  {
    "code": "JP-20-54",
    "name": "Nagiso"
  },
  {
    "code": "JP-47-05",
    "name": "Nago"
  },
  {
    "code": "JP-43-19",
    "name": "Nagomi"
  },
  {
    "code": "JP-23-01",
    "name": "Nagoya"
  },
  {
    "code": "JP-47-01",
    "name": "Naha"
  },
  {
    "code": "JP-39-13",
    "name": "Nahari"
  },
  {
    "code": "JP-01-74",
    "name": "Naie"
  },
  {
    "code": "JP-08-22",
    "name": "Naka"
  },
  {
    "code": "JP-36-14",
    "name": "Naka"
  },
  {
    "code": "JP-02-23",
    "name": "Nakadomari"
  },
  {
    "code": "JP-01-96",
    "name": "Nakafurano"
  },
  {
    "code": "JP-01-104",
    "name": "Nakagawa"
  },
  {
    "code": "JP-20-38",
    "name": "Nakagawa"
  },
  {
    "code": "JP-40-29",
    "name": "Nakagawa"
  },
  {
    "code": "JP-09-25",
    "name": "Nakagawa"
  },
  {
    "code": "JP-47-25",
    "name": "Nakagusuku"
  },
  {
    "code": "JP-14-24",
    "name": "Nakai"
  },
  {
    "code": "JP-07-37",
    "name": "Nakajima"
  },
  {
    "code": "JP-40-14",
    "name": "Nakama"
  },
  {
    "code": "JP-20-11",
    "name": "Nakano"
  },
  {
    "code": "JP-13-14",
    "name": "Nakano City"
  },
  {
    "code": "JP-10-20",
    "name": "Nakanojo"
  },
  {
    "code": "JP-17-17",
    "name": "Nakanoto"
  },
  {
    "code": "JP-01-158",
    "name": "Nakasatsunai"
  },
  {
    "code": "JP-01-177",
    "name": "Nakashibetsu"
  },
  {
    "code": "JP-46-30",
    "name": "Nakatane"
  },
  {
    "code": "JP-01-115",
    "name": "Nakatombetsu"
  },
  {
    "code": "JP-39-25",
    "name": "Nakatosa"
  },
  {
    "code": "JP-44-03",
    "name": "Nakatsu"
  },
  {
    "code": "JP-21-06",
    "name": "Nakatsugawa"
  },
  {
    "code": "JP-06-15",
    "name": "Nakayama"
  },
  {
    "code": "JP-47-15",
    "name": "Nakijin"
  },
  {
    "code": "JP-19-17",
    "name": "Nambu"
  },
  {
    "code": "JP-31-15",
    "name": "Nambu"
  },
  {
    "code": "JP-02-38",
    "name": "Nambu"
  },
  {
    "code": "JP-08-29",
    "name": "Namegata"
  },
  {
    "code": "JP-11-44",
    "name": "Namegawa"
  },
  {
    "code": "JP-16-05",
    "name": "Namerikawa"
  },
  {
    "code": "JP-07-56",
    "name": "Namie"
  },
  {
    "code": "JP-10-18",
    "name": "Nammoku"
  },
  {
    "code": "JP-01-73",
    "name": "Namporo"
  },
  {
    "code": "JP-01-42",
    "name": "Nanae"
  },
  {
    "code": "JP-17-02",
    "name": "Nanao"
  },
  {
    "code": "JP-47-11",
    "name": "Nanjo"
  },
  {
    "code": "JP-43-17",
    "name": "Nankan"
  },
  {
    "code": "JP-39-04",
    "name": "Nankoku"
  },
  {
    "code": "JP-26-14",
    "name": "Nantan"
  },
  {
    "code": "JP-16-09",
    "name": "Nanto"
  },
  {
    "code": "JP-06-13",
    "name": "Nanyo"
  },
  {
    "code": "JP-37-12",
    "name": "Naoshima"
  },
  {
    "code": "JP-29-01",
    "name": "Nara"
  },
  {
    "code": "JP-07-51",
    "name": "Naraha"
  },
  {
    "code": "JP-12-14",
    "name": "Narashino"
  },
  {
    "code": "JP-12-10",
    "name": "Narita"
  },
  {
    "code": "JP-19-24",
    "name": "Narusawa"
  },
  {
    "code": "JP-36-02",
    "name": "Naruto"
  },
  {
    "code": "JP-09-24",
    "name": "Nasu"
  },
  {
    "code": "JP-09-13",
    "name": "Nasukarasuyama"
  },
  {
    "code": "JP-09-11",
    "name": "Nasushiobara"
  },
  {
    "code": "JP-04-06",
    "name": "Natori"
  },
  {
    "code": "JP-01-21",
    "name": "Nayoro"
  },
  {
    "code": "JP-20-45",
    "name": "Neba"
  },
  {
    "code": "JP-01-23",
    "name": "Nemuro"
  },
  {
    "code": "JP-13-20",
    "name": "Nerima City"
  },
  {
    "code": "JP-27-16",
    "name": "Neyagawa"
  },
  {
    "code": "JP-45-04",
    "name": "Nichinan"
  },
  {
    "code": "JP-31-17",
    "name": "Nichinan"
  },
  {
    "code": "JP-07-09",
    "name": "Nihommatsu"
  },
  {
    "code": "JP-15-01",
    "name": "Niigata"
  },
  {
    "code": "JP-38-05",
    "name": "Niihama"
  },
  {
    "code": "JP-13-56",
    "name": "Niijima"
  },
  {
    "code": "JP-01-146",
    "name": "Niikappu"
  },
  {
    "code": "JP-33-09",
    "name": "Niimi"
  },
  {
    "code": "JP-11-26",
    "name": "Niiza"
  },
  {
    "code": "JP-05-12",
    "name": "Nikaho"
  },
  {
    "code": "JP-01-70",
    "name": "Niki"
  },
  {
    "code": "JP-09-06",
    "name": "Nikko"
  },
  {
    "code": "JP-03-11",
    "name": "Ninohe"
  },
  {
    "code": "JP-14-23",
    "name": "Ninomiya"
  },
  {
    "code": "JP-19-06",
    "name": "Nirasaki"
  },
  {
    "code": "JP-01-58",
    "name": "Niseko"
  },
  {
    "code": "JP-07-25",
    "name": "Nishiaizu"
  },
  {
    "code": "JP-33-24",
    "name": "Nishiawakura"
  },
  {
    "code": "JP-07-35",
    "name": "Nishigo"
  },
  {
    "code": "JP-47-26",
    "name": "Nishihara"
  },
  {
    "code": "JP-43-26",
    "name": "Nishihara"
  },
  {
    "code": "JP-22-28",
    "name": "Nishiizu"
  },
  {
    "code": "JP-19-21",
    "name": "Nishikatsura"
  },
  {
    "code": "JP-06-17",
    "name": "Nishikawa"
  },
  {
    "code": "JP-43-36",
    "name": "Nishiki"
  },
  {
    "code": "JP-45-16",
    "name": "Nishimera"
  },
  {
    "code": "JP-02-17",
    "name": "Nishimeya"
  },
  {
    "code": "JP-28-05",
    "name": "Nishinomiya"
  },
  {
    "code": "JP-46-07",
    "name": "Nishinoomote"
  },
  {
    "code": "JP-32-17",
    "name": "Nishinoshima"
  },
  {
    "code": "JP-23-14",
    "name": "Nishio"
  },
  {
    "code": "JP-01-134",
    "name": "Nishiokoppe"
  },
  {
    "code": "JP-13-49",
    "name": "Nishitokyo"
  },
  {
    "code": "JP-03-20",
    "name": "Nishiwaga"
  },
  {
    "code": "JP-28-13",
    "name": "Nishiwaki"
  },
  {
    "code": "JP-23-30",
    "name": "Nisshin"
  },
  {
    "code": "JP-39-24",
    "name": "Niyodogawa"
  },
  {
    "code": "JP-45-03",
    "name": "Nobeoka"
  },
  {
    "code": "JP-01-30",
    "name": "Noboribetsu"
  },
  {
    "code": "JP-12-08",
    "name": "Noda"
  },
  {
    "code": "JP-03-30",
    "name": "Noda"
  },
  {
    "code": "JP-40-05",
    "name": "Nogata"
  },
  {
    "code": "JP-09-21",
    "name": "Nogi"
  },
  {
    "code": "JP-02-24",
    "name": "Noheji"
  },
  {
    "code": "JP-17-10",
    "name": "Nomi"
  },
  {
    "code": "JP-17-12",
    "name": "Nonoichi"
  },
  {
    "code": "JP-27-36",
    "name": "Nose"
  },
  {
    "code": "JP-29-34",
    "name": "Nosegawa"
  },
  {
    "code": "JP-05-02",
    "name": "Noshiro"
  },
  {
    "code": "JP-17-19",
    "name": "Noto"
  },
  {
    "code": "JP-20-73",
    "name": "Nozawaonsen"
  },
  {
    "code": "JP-01-86",
    "name": "Numata"
  },
  {
    "code": "JP-10-06",
    "name": "Numata"
  },
  {
    "code": "JP-22-03",
    "name": "Numazu"
  },
  {
    "code": "JP-16-14",
    "name": "Nyuzen"
  },
  {
    "code": "JP-12-42",
    "name": "Oamishirasato"
  },
  {
    "code": "JP-08-34",
    "name": "Oarai"
  },
  {
    "code": "JP-18-03",
    "name": "Obama"
  },
  {
    "code": "JP-06-12",
    "name": "Obanazawa"
  },
  {
    "code": "JP-01-07",
    "name": "Obihiro"
  },
  {
    "code": "JP-01-107",
    "name": "Obira"
  },
  {
    "code": "JP-23-23",
    "name": "Obu"
  },
  {
    "code": "JP-20-69",
    "name": "Obuse"
  },
  {
    "code": "JP-39-27",
    "name": "Ochi"
  },
  {
    "code": "JP-32-05",
    "name": "Oda"
  },
  {
    "code": "JP-24-22",
    "name": "Odai"
  },
  {
    "code": "JP-05-04",
    "name": "Odate"
  },
  {
    "code": "JP-14-08",
    "name": "Odawara"
  },
  {
    "code": "JP-06-19",
    "name": "Oe"
  },
  {
    "code": "JP-03-03",
    "name": "Ofunato"
  },
  {
    "code": "JP-05-05",
    "name": "Oga"
  },
  {
    "code": "JP-21-02",
    "name": "Ogaki"
  },
  {
    "code": "JP-11-54",
    "name": "Ogano"
  },
  {
    "code": "JP-13-62",
    "name": "Ogasawara"
  },
  {
    "code": "JP-05-22",
    "name": "Ogata"
  },
  {
    "code": "JP-20-75",
    "name": "Ogawa"
  },
  {
    "code": "JP-11-46",
    "name": "Ogawa"
  },
  {
    "code": "JP-04-16",
    "name": "Ogawara"
  },
  {
    "code": "JP-41-08",
    "name": "Ogi"
  },
  {
    "code": "JP-47-13",
    "name": "Ogimi"
  },
  {
    "code": "JP-40-15",
    "name": "Ogori"
  },
  {
    "code": "JP-11-43",
    "name": "Ogose"
  },
  {
    "code": "JP-23-41",
    "name": "Oguchi"
  },
  {
    "code": "JP-06-30",
    "name": "Oguni"
  },
  {
    "code": "JP-43-23",
    "name": "Oguni"
  },
  {
    "code": "JP-23-43",
    "name": "Oharu"
  },
  {
    "code": "JP-04-29",
    "name": "Ohira"
  },
  {
    "code": "JP-18-16",
    "name": "Oi"
  },
  {
    "code": "JP-14-25",
    "name": "Oi"
  },
  {
    "code": "JP-02-30",
    "name": "Oirase"
  },
  {
    "code": "JP-06-20",
    "name": "Oishida"
  },
  {
    "code": "JP-14-22",
    "name": "Oiso"
  },
  {
    "code": "JP-44-01",
    "name": "Oita"
  },
  {
    "code": "JP-10-34",
    "name": "Oizumi"
  },
  {
    "code": "JP-29-26",
    "name": "Oji"
  },
  {
    "code": "JP-42-19",
    "name": "Ojika"
  },
  {
    "code": "JP-15-06",
    "name": "Ojiya"
  },
  {
    "code": "JP-40-39",
    "name": "Okagaki"
  },
  {
    "code": "JP-40-11",
    "name": "Okawa"
  },
  {
    "code": "JP-39-22",
    "name": "Okawa"
  },
  {
    "code": "JP-20-04",
    "name": "Okaya"
  },
  {
    "code": "JP-33-01",
    "name": "Okayama"
  },
  {
    "code": "JP-23-03",
    "name": "Okazaki"
  },
  {
    "code": "JP-11-27",
    "name": "Okegawa"
  },
  {
    "code": "JP-01-128",
    "name": "Oketo"
  },
  {
    "code": "JP-40-47",
    "name": "Oki"
  },
  {
    "code": "JP-47-07",
    "name": "Okinawa"
  },
  {
    "code": "JP-32-19",
    "name": "Okinoshima"
  },
  {
    "code": "JP-01-133",
    "name": "Okoppe"
  },
  {
    "code": "JP-32-09",
    "name": "Okuizumo"
  },
  {
    "code": "JP-07-54",
    "name": "Okuma"
  },
  {
    "code": "JP-06-25",
    "name": "Okura"
  },
  {
    "code": "JP-01-51",
    "name": "Okushiri"
  },
  {
    "code": "JP-13-53",
    "name": "Okutama"
  },
  {
    "code": "JP-20-57",
    "name": "Okuwa"
  },
  {
    "code": "JP-02-31",
    "name": "Oma"
  },
  {
    "code": "JP-41-17",
    "name": "Omachi"
  },
  {
    "code": "JP-20-12",
    "name": "Omachi"
  },
  {
    "code": "JP-22-20",
    "name": "Omaezaki"
  },
  {
    "code": "JP-13-28",
    "name": "Ome"
  },
  {
    "code": "JP-20-59",
    "name": "Omi"
  },
  {
    "code": "JP-25-04",
    "name": "Omihachiman"
  },
  {
    "code": "JP-08-32",
    "name": "Omitama"
  },
  {
    "code": "JP-01-135",
    "name": "Omu"
  },
  {
    "code": "JP-42-05",
    "name": "Omura"
  },
  {
    "code": "JP-40-03",
    "name": "Omuta"
  },
  {
    "code": "JP-04-34",
    "name": "Onagawa"
  },
  {
    "code": "JP-32-13",
    "name": "Onan"
  },
  {
    "code": "JP-40-40",
    "name": "Onga"
  },
  {
    "code": "JP-12-53",
    "name": "Onjuku"
  },
  {
    "code": "JP-47-17",
    "name": "Onna"
  },
  {
    "code": "JP-21-31",
    "name": "Ono"
  },
  {
    "code": "JP-28-18",
    "name": "Ono"
  },
  {
    "code": "JP-07-49",
    "name": "Ono"
  },
  {
    "code": "JP-18-04",
    "name": "Ono"
  },
  {
    "code": "JP-40-18",
    "name": "Onojo"
  },
  {
    "code": "JP-34-05",
    "name": "Onomichi"
  },
  {
    "code": "JP-10-35",
    "name": "Ora"
  },
  {
    "code": "JP-27-01",
    "name": "Osaka"
  },
  {
    "code": "JP-27-32",
    "name": "Osakasayama"
  },
  {
    "code": "JP-04-13",
    "name": "Osaki"
  },
  {
    "code": "JP-46-25",
    "name": "Osaki"
  },
  {
    "code": "JP-34-21",
    "name": "Osakikamijima"
  },
  {
    "code": "JP-04-27",
    "name": "Osato"
  },
  {
    "code": "JP-01-46",
    "name": "Oshamambe"
  },
  {
    "code": "JP-20-52",
    "name": "Oshika"
  },
  {
    "code": "JP-13-54",
    "name": "Oshima"
  },
  {
    "code": "JP-19-22",
    "name": "Oshino"
  },
  {
    "code": "JP-03-13",
    "name": "Oshu"
  },
  {
    "code": "JP-10-05",
    "name": "Ota"
  },
  {
    "code": "JP-13-11",
    "name": "Ota City"
  },
  {
    "code": "JP-34-10",
    "name": "Otake"
  },
  {
    "code": "JP-12-52",
    "name": "Otaki"
  },
  {
    "code": "JP-20-56",
    "name": "Otaki"
  },
  {
    "code": "JP-07-17",
    "name": "Otama"
  },
  {
    "code": "JP-20-67",
    "name": "Otari"
  },
  {
    "code": "JP-01-03",
    "name": "Otaru"
  },
  {
    "code": "JP-09-09",
    "name": "Otawara"
  },
  {
    "code": "JP-40-53",
    "name": "Oto"
  },
  {
    "code": "JP-01-50",
    "name": "Otobe"
  },
  {
    "code": "JP-01-151",
    "name": "Otofuke"
  },
  {
    "code": "JP-01-103",
    "name": "Otoineppu"
  },
  {
    "code": "JP-39-20",
    "name": "Otoyo"
  },
  {
    "code": "JP-25-01",
    "name": "Otsu"
  },
  {
    "code": "JP-03-24",
    "name": "Otsuchi"
  },
  {
    "code": "JP-19-05",
    "name": "Otsuki"
  },
  {
    "code": "JP-39-32",
    "name": "Otsuki"
  },
  {
    "code": "JP-02-19",
    "name": "Owani"
  },
  {
    "code": "JP-23-26",
    "name": "Owariasahi"
  },
  {
    "code": "JP-24-08",
    "name": "Owase"
  },
  {
    "code": "JP-16-08",
    "name": "Oyabe"
  },
  {
    "code": "JP-22-32",
    "name": "Oyama"
  },
  {
    "code": "JP-09-07",
    "name": "Oyama"
  },
  {
    "code": "JP-26-16",
    "name": "Oyamazaki"
  },
  {
    "code": "JP-29-30",
    "name": "Oyodo"
  },
  {
    "code": "JP-01-136",
    "name": "Ozora"
  },
  {
    "code": "JP-43-20",
    "name": "Ozu"
  },
  {
    "code": "JP-38-07",
    "name": "Ozu"
  },
  {
    "code": "JP-01-90",
    "name": "Pippu"
  },
  {
    "code": "JP-01-57",
    "name": "Rankoshi"
  },
  {
    "code": "JP-11-45",
    "name": "Ranzan"
  },
  {
    "code": "JP-01-179",
    "name": "Rausu"
  },
  {
    "code": "JP-01-118",
    "name": "Rebun"
  },
  {
    "code": "JP-43-45",
    "name": "Reihoku"
  },
  {
    "code": "JP-04-25",
    "name": "Rifu"
  },
  {
    "code": "JP-01-167",
    "name": "Rikubetsu"
  },
  {
    "code": "JP-03-09",
    "name": "Rikuzentakata"
  },
  {
    "code": "JP-01-119",
    "name": "Rishiri"
  },
  {
    "code": "JP-01-120",
    "name": "Rishirifuji"
  },
  {
    "code": "JP-25-07",
    "name": "Ritto"
  },
  {
    "code": "JP-02-29",
    "name": "Rokkasho"
  },
  {
    "code": "JP-02-26",
    "name": "Rokunohe"
  },
  {
    "code": "JP-01-12",
    "name": "Rumoi"
  },
  {
    "code": "JP-01-60",
    "name": "Rusutsu"
  },
  {
    "code": "JP-08-07",
    "name": "Ryugasaki"
  },
  {
    "code": "JP-25-15",
    "name": "Ryuo"
  },
  {
    "code": "JP-18-06",
    "name": "Sabae"
  },
  {
    "code": "JP-15-17",
    "name": "Sado"
  },
  {
    "code": "JP-41-01",
    "name": "Saga"
  },
  {
    "code": "JP-06-06",
    "name": "Sagae"
  },
  {
    "code": "JP-14-03",
    "name": "Sagamihara"
  },
  {
    "code": "JP-43-40",
    "name": "Sagara"
  },
  {
    "code": "JP-02-34",
    "name": "Sai"
  },
  {
    "code": "JP-38-06",
    "name": "Saijo"
  },
  {
    "code": "JP-42-11",
    "name": "Saikai"
  },
  {
    "code": "JP-44-05",
    "name": "Saiki"
  },
  {
    "code": "JP-11-01",
    "name": "Saitama"
  },
  {
    "code": "JP-45-08",
    "name": "Saito"
  },
  {
    "code": "JP-34-18",
    "name": "Saka"
  },
  {
    "code": "JP-11-34",
    "name": "Sakado"
  },
  {
    "code": "JP-12-38",
    "name": "Sakae"
  },
  {
    "code": "JP-20-77",
    "name": "Sakae"
  },
  {
    "code": "JP-21-34",
    "name": "Sakahogi"
  },
  {
    "code": "JP-08-43",
    "name": "Sakai"
  },
  {
    "code": "JP-27-02",
    "name": "Sakai"
  },
  {
    "code": "JP-18-09",
    "name": "Sakai"
  },
  {
    "code": "JP-37-03",
    "name": "Sakaide"
  },
  {
    "code": "JP-31-04",
    "name": "Sakaiminato"
  },
  {
    "code": "JP-20-68",
    "name": "Sakaki"
  },
  {
    "code": "JP-06-04",
    "name": "Sakata"
  },
  {
    "code": "JP-39-26",
    "name": "Sakawa"
  },
  {
    "code": "JP-06-26",
    "name": "Sakegawa"
  },
  {
    "code": "JP-20-16",
    "name": "Saku"
  },
  {
    "code": "JP-20-25",
    "name": "Sakuho"
  },
  {
    "code": "JP-12-11",
    "name": "Sakura"
  },
  {
    "code": "JP-09-12",
    "name": "Sakura"
  },
  {
    "code": "JP-08-27",
    "name": "Sakuragawa"
  },
  {
    "code": "JP-29-06",
    "name": "Sakurai"
  },
  {
    "code": "JP-01-148",
    "name": "Samani"
  },
  {
    "code": "JP-07-42",
    "name": "Samegawa"
  },
  {
    "code": "JP-12-35",
    "name": "Sammu"
  },
  {
    "code": "JP-14-21",
    "name": "Samukawa"
  },
  {
    "code": "JP-36-11",
    "name": "Sanagochi"
  },
  {
    "code": "JP-28-19",
    "name": "Sanda"
  },
  {
    "code": "JP-29-15",
    "name": "Sango"
  },
  {
    "code": "JP-15-03",
    "name": "Sanjo"
  },
  {
    "code": "JP-02-35",
    "name": "Sannohe"
  },
  {
    "code": "JP-09-04",
    "name": "Sano"
  },
  {
    "code": "JP-37-06",
    "name": "Sanuki"
  },
  {
    "code": "JP-35-13",
    "name": "Sanyoonoda"
  },
  {
    "code": "JP-01-01",
    "name": "Sapporo"
  },
  {
    "code": "JP-01-159",
    "name": "Sarabetsu"
  },
  {
    "code": "JP-01-129",
    "name": "Saroma"
  },
  {
    "code": "JP-01-113",
    "name": "Sarufutsu"
  },
  {
    "code": "JP-40-31",
    "name": "Sasaguri"
  },
  {
    "code": "JP-42-02",
    "name": "Sasebo"
  },
  {
    "code": "JP-33-18",
    "name": "Satosho"
  },
  {
    "code": "JP-46-22",
    "name": "Satsuma"
  },
  {
    "code": "JP-46-09",
    "name": "Satsumasendai"
  },
  {
    "code": "JP-11-35",
    "name": "Satte"
  },
  {
    "code": "JP-11-13",
    "name": "Sayama"
  },
  {
    "code": "JP-28-39",
    "name": "Sayo"
  },
  {
    "code": "JP-42-20",
    "name": "Saza"
  },
  {
    "code": "JP-26-22",
    "name": "Seika"
  },
  {
    "code": "JP-15-21",
    "name": "Seiro"
  },
  {
    "code": "JP-38-10",
    "name": "Seiyo"
  },
  {
    "code": "JP-21-05",
    "name": "Seki"
  },
  {
    "code": "JP-21-26",
    "name": "Sekigahara"
  },
  {
    "code": "JP-15-29",
    "name": "Sekikawa"
  },
  {
    "code": "JP-05-13",
    "name": "Semboku"
  },
  {
    "code": "JP-04-01",
    "name": "Sendai"
  },
  {
    "code": "JP-27-29",
    "name": "Sennan"
  },
  {
    "code": "JP-34-22",
    "name": "Sera"
  },
  {
    "code": "JP-13-12",
    "name": "Setagaya City"
  },
  {
    "code": "JP-01-53",
    "name": "Setana"
  },
  {
    "code": "JP-23-05",
    "name": "Seto"
  },
  {
    "code": "JP-33-11",
    "name": "Setouchi"
  },
  {
    "code": "JP-46-35",
    "name": "Setouchi"
  },
  {
    "code": "JP-27-25",
    "name": "Settsu"
  },
  {
    "code": "JP-01-68",
    "name": "Shakotan"
  },
  {
    "code": "JP-01-124",
    "name": "Shari"
  },
  {
    "code": "JP-04-18",
    "name": "Shibata"
  },
  {
    "code": "JP-15-05",
    "name": "Shibata"
  },
  {
    "code": "JP-12-44",
    "name": "Shibayama"
  },
  {
    "code": "JP-01-172",
    "name": "Shibecha"
  },
  {
    "code": "JP-01-20",
    "name": "Shibetsu"
  },
  {
    "code": "JP-01-178",
    "name": "Shibetsu"
  },
  {
    "code": "JP-10-08",
    "name": "Shibukawa"
  },
  {
    "code": "JP-46-15",
    "name": "Shibushi"
  },
  {
    "code": "JP-13-13",
    "name": "Shibuya City"
  },
  {
    "code": "JP-04-24",
    "name": "Shichigahama"
  },
  {
    "code": "JP-04-15",
    "name": "Shichikashuku"
  },
  {
    "code": "JP-02-25",
    "name": "Shichinohe"
  },
  {
    "code": "JP-01-152",
    "name": "Shihoro"
  },
  {
    "code": "JP-45-22",
    "name": "Shiiba"
  },
  {
    "code": "JP-27-30",
    "name": "Shijonawate"
  },
  {
    "code": "JP-17-15",
    "name": "Shika"
  },
  {
    "code": "JP-01-43",
    "name": "Shikabe"
  },
  {
    "code": "JP-04-30",
    "name": "Shikama"
  },
  {
    "code": "JP-01-154",
    "name": "Shikaoi"
  },
  {
    "code": "JP-11-24",
    "name": "Shiki"
  },
  {
    "code": "JP-38-09",
    "name": "Shikokuchuo"
  },
  {
    "code": "JP-24-13",
    "name": "Shima"
  },
  {
    "code": "JP-42-03",
    "name": "Shimabara"
  },
  {
    "code": "JP-22-08",
    "name": "Shimada"
  },
  {
    "code": "JP-01-54",
    "name": "Shimamaki"
  },
  {
    "code": "JP-27-34",
    "name": "Shimamoto"
  },
  {
    "code": "JP-39-09",
    "name": "Shimanto"
  },
  {
    "code": "JP-39-31",
    "name": "Shimanto"
  },
  {
    "code": "JP-40-32",
    "name": "Shime"
  },
  {
    "code": "JP-01-156",
    "name": "Shimizu"
  },
  {
    "code": "JP-22-30",
    "name": "Shimizu"
  },
  {
    "code": "JP-22-16",
    "name": "Shimoda"
  },
  {
    "code": "JP-07-20",
    "name": "Shimogo"
  },
  {
    "code": "JP-29-31",
    "name": "Shimoichi"
  },
  {
    "code": "JP-20-46",
    "name": "Shimojo"
  },
  {
    "code": "JP-01-101",
    "name": "Shimokawa"
  },
  {
    "code": "JP-29-36",
    "name": "Shimokitayama"
  },
  {
    "code": "JP-10-17",
    "name": "Shimonita"
  },
  {
    "code": "JP-35-01",
    "name": "Shimonoseki"
  },
  {
    "code": "JP-20-31",
    "name": "Shimosuwa"
  },
  {
    "code": "JP-09-14",
    "name": "Shimotsuke"
  },
  {
    "code": "JP-08-08",
    "name": "Shimotsuma"
  },
  {
    "code": "JP-01-98",
    "name": "Shimukappu"
  },
  {
    "code": "JP-13-09",
    "name": "Shinagawa City"
  },
  {
    "code": "JP-20-74",
    "name": "Shinano"
  },
  {
    "code": "JP-07-58",
    "name": "Shinchi"
  },
  {
    "code": "JP-02-40",
    "name": "Shingo"
  },
  {
    "code": "JP-40-34",
    "name": "Shingu"
  },
  {
    "code": "JP-30-07",
    "name": "Shingu"
  },
  {
    "code": "JP-01-150",
    "name": "Shinhidaka"
  },
  {
    "code": "JP-33-20",
    "name": "Shinjo"
  },
  {
    "code": "JP-06-05",
    "name": "Shinjo"
  },
  {
    "code": "JP-13-04",
    "name": "Shinjuku City"
  },
  {
    "code": "JP-42-21",
    "name": "Shinkamigoto"
  },
  {
    "code": "JP-28-41",
    "name": "Shinonsen"
  },
  {
    "code": "JP-01-37",
    "name": "Shinshinotsu"
  },
  {
    "code": "JP-23-21",
    "name": "Shinshiro"
  },
  {
    "code": "JP-10-13",
    "name": "Shinto"
  },
  {
    "code": "JP-01-155",
    "name": "Shintoku"
  },
  {
    "code": "JP-45-15",
    "name": "Shintomi"
  },
  {
    "code": "JP-01-81",
    "name": "Shintotsukawa"
  },
  {
    "code": "JP-04-03",
    "name": "Shiogama"
  },
  {
    "code": "JP-20-15",
    "name": "Shiojiri"
  },
  {
    "code": "JP-09-22",
    "name": "Shioya"
  },
  {
    "code": "JP-30-23",
    "name": "Shirahama"
  },
  {
    "code": "JP-21-42",
    "name": "Shirakawa"
  },
  {
    "code": "JP-21-39",
    "name": "Shirakawa"
  },
  {
    "code": "JP-07-05",
    "name": "Shirakawa"
  },
  {
    "code": "JP-12-49",
    "name": "Shirako"
  },
  {
    "code": "JP-01-175",
    "name": "Shiranuka"
  },
  {
    "code": "JP-01-139",
    "name": "Shiraoi"
  },
  {
    "code": "JP-11-61",
    "name": "Shiraoka"
  },
  {
    "code": "JP-06-31",
    "name": "Shirataka"
  },
  {
    "code": "JP-01-40",
    "name": "Shiriuchi"
  },
  {
    "code": "JP-12-30",
    "name": "Shiroi"
  },
  {
    "code": "JP-41-19",
    "name": "Shiroishi"
  },
  {
    "code": "JP-04-05",
    "name": "Shiroishi"
  },
  {
    "code": "JP-08-35",
    "name": "Shirosato"
  },
  {
    "code": "JP-28-27",
    "name": "Shiso"
  },
  {
    "code": "JP-12-37",
    "name": "Shisui"
  },
  {
    "code": "JP-23-52",
    "name": "Shitara"
  },
  {
    "code": "JP-03-18",
    "name": "Shiwa"
  },
  {
    "code": "JP-03-14",
    "name": "Shizukuishi"
  },
  {
    "code": "JP-22-01",
    "name": "Shizuoka"
  },
  {
    "code": "JP-34-09",
    "name": "Shobara"
  },
  {
    "code": "JP-37-10",
    "name": "Shodoshima"
  },
  {
    "code": "JP-06-34",
    "name": "Shonai"
  },
  {
    "code": "JP-33-22",
    "name": "Shoo"
  },
  {
    "code": "JP-01-110",
    "name": "Shosambetsu"
  },
  {
    "code": "JP-19-19",
    "name": "Showa"
  },
  {
    "code": "JP-07-33",
    "name": "Showa"
  },
  {
    "code": "JP-10-28",
    "name": "Showa"
  },
  {
    "code": "JP-35-12",
    "name": "Shunan"
  },
  {
    "code": "JP-01-138",
    "name": "Sobetsu"
  },
  {
    "code": "JP-12-27",
    "name": "Sodegaura"
  },
  {
    "code": "JP-40-50",
    "name": "Soeda"
  },
  {
    "code": "JP-33-07",
    "name": "Soja"
  },
  {
    "code": "JP-11-18",
    "name": "Soka"
  },
  {
    "code": "JP-07-08",
    "name": "Soma"
  },
  {
    "code": "JP-29-21",
    "name": "Soni"
  },
  {
    "code": "JP-46-11",
    "name": "Soo"
  },
  {
    "code": "JP-12-33",
    "name": "Sosa"
  },
  {
    "code": "JP-02-14",
    "name": "Sotogahama"
  },
  {
    "code": "JP-40-33",
    "name": "Sue"
  },
  {
    "code": "JP-13-15",
    "name": "Suginami City"
  },
  {
    "code": "JP-11-62",
    "name": "Sugito"
  },
  {
    "code": "JP-27-06",
    "name": "Suita"
  },
  {
    "code": "JP-07-06",
    "name": "Sukagawa"
  },
  {
    "code": "JP-39-07",
    "name": "Sukumo"
  },
  {
    "code": "JP-13-07",
    "name": "Sumida City"
  },
  {
    "code": "JP-03-23",
    "name": "Sumita"
  },
  {
    "code": "JP-28-06",
    "name": "Sumoto"
  },
  {
    "code": "JP-01-26",
    "name": "Sunagawa"
  },
  {
    "code": "JP-35-14",
    "name": "Suooshima"
  },
  {
    "code": "JP-39-06",
    "name": "Susaki"
  },
  {
    "code": "JP-30-25",
    "name": "Susami"
  },
  {
    "code": "JP-22-17",
    "name": "Susono"
  },
  {
    "code": "JP-01-55",
    "name": "Suttsu"
  },
  {
    "code": "JP-20-06",
    "name": "Suwa"
  },
  {
    "code": "JP-20-07",
    "name": "Suzaka"
  },
  {
    "code": "JP-17-05",
    "name": "Suzu"
  },
  {
    "code": "JP-24-06",
    "name": "Suzuka"
  },
  {
    "code": "JP-19-27",
    "name": "Tabayama"
  },
  {
    "code": "JP-35-17",
    "name": "Tabuse"
  },
  {
    "code": "JP-40-46",
    "name": "Tachiarai"
  },
  {
    "code": "JP-13-25",
    "name": "Tachikawa"
  },
  {
    "code": "JP-07-22",
    "name": "Tadami"
  },
  {
    "code": "JP-27-37",
    "name": "Tadaoka"
  },
  {
    "code": "JP-37-16",
    "name": "Tadotsu"
  },
  {
    "code": "JP-25-19",
    "name": "Taga"
  },
  {
    "code": "JP-04-08",
    "name": "Tagajo"
  },
  {
    "code": "JP-15-23",
    "name": "Tagami"
  },
  {
    "code": "JP-40-07",
    "name": "Tagawa"
  },
  {
    "code": "JP-23-31",
    "name": "Tahara"
  },
  {
    "code": "JP-30-27",
    "name": "Taiji"
  },
  {
    "code": "JP-01-160",
    "name": "Taiki"
  },
  {
    "code": "JP-24-25",
    "name": "Taiki"
  },
  {
    "code": "JP-15-20",
    "name": "Tainai"
  },
  {
    "code": "JP-28-37",
    "name": "Taishi"
  },
  {
    "code": "JP-27-41",
    "name": "Taishi"
  },
  {
    "code": "JP-13-06",
    "name": "Taito City"
  },
  {
    "code": "JP-04-26",
    "name": "Taiwa"
  },
  {
    "code": "JP-21-04",
    "name": "Tajimi"
  },
  {
    "code": "JP-27-39",
    "name": "Tajiri"
  },
  {
    "code": "JP-28-31",
    "name": "Taka"
  },
  {
    "code": "JP-45-24",
    "name": "Takachiho"
  },
  {
    "code": "JP-20-50",
    "name": "Takagi"
  },
  {
    "code": "JP-08-11",
    "name": "Takahagi"
  },
  {
    "code": "JP-23-27",
    "name": "Takahama"
  },
  {
    "code": "JP-18-15",
    "name": "Takahama"
  },
  {
    "code": "JP-45-11",
    "name": "Takaharu"
  },
  {
    "code": "JP-33-08",
    "name": "Takahashi"
  },
  {
    "code": "JP-06-28",
    "name": "Takahata"
  },
  {
    "code": "JP-27-26",
    "name": "Takaishi"
  },
  {
    "code": "JP-37-01",
    "name": "Takamatsu"
  },
  {
    "code": "JP-20-41",
    "name": "Takamori"
  },
  {
    "code": "JP-43-25",
    "name": "Takamori"
  },
  {
    "code": "JP-45-14",
    "name": "Takanabe"
  },
  {
    "code": "JP-09-23",
    "name": "Takanezawa"
  },
  {
    "code": "JP-16-02",
    "name": "Takaoka"
  },
  {
    "code": "JP-28-14",
    "name": "Takarazuka"
  },
  {
    "code": "JP-28-16",
    "name": "Takasago"
  },
  {
    "code": "JP-10-02",
    "name": "Takasaki"
  },
  {
    "code": "JP-25-11",
    "name": "Takashima"
  },
  {
    "code": "JP-01-87",
    "name": "Takasu"
  },
  {
    "code": "JP-29-23",
    "name": "Takatori"
  },
  {
    "code": "JP-27-08",
    "name": "Takatsuki"
  },
  {
    "code": "JP-21-03",
    "name": "Takayama"
  },
  {
    "code": "JP-20-70",
    "name": "Takayama"
  },
  {
    "code": "JP-10-24",
    "name": "Takayama"
  },
  {
    "code": "JP-34-03",
    "name": "Takehara"
  },
  {
    "code": "JP-41-06",
    "name": "Takeo"
  },
  {
    "code": "JP-44-08",
    "name": "Taketa"
  },
  {
    "code": "JP-47-40",
    "name": "Taketomi"
  },
  {
    "code": "JP-23-50",
    "name": "Taketoyo"
  },
  {
    "code": "JP-24-20",
    "name": "Taki"
  },
  {
    "code": "JP-01-25",
    "name": "Takikawa"
  },
  {
    "code": "JP-01-132",
    "name": "Takinoe"
  },
  {
    "code": "JP-03-17",
    "name": "Takizawa"
  },
  {
    "code": "JP-02-37",
    "name": "Takko"
  },
  {
    "code": "JP-12-40",
    "name": "Tako"
  },
  {
    "code": "JP-41-04",
    "name": "Taku"
  },
  {
    "code": "JP-13-45",
    "name": "Tama"
  },
  {
    "code": "JP-07-44",
    "name": "Tamakawa"
  },
  {
    "code": "JP-24-23",
    "name": "Tamaki"
  },
  {
    "code": "JP-10-30",
    "name": "Tamamura"
  },
  {
    "code": "JP-43-06",
    "name": "Tamana"
  },
  {
    "code": "JP-33-04",
    "name": "Tamano"
  },
  {
    "code": "JP-28-23",
    "name": "Tamba"
  },
  {
    "code": "JP-28-21",
    "name": "Tamba-Sasayama"
  },
  {
    "code": "JP-07-10",
    "name": "Tamura"
  },
  {
    "code": "JP-30-06",
    "name": "Tanabe"
  },
  {
    "code": "JP-07-39",
    "name": "Tanagura"
  },
  {
    "code": "JP-39-14",
    "name": "Tano"
  },
  {
    "code": "JP-03-27",
    "name": "Tanohata"
  },
  {
    "code": "JP-41-20",
    "name": "Tara"
  },
  {
    "code": "JP-43-37",
    "name": "Taragi"
  },
  {
    "code": "JP-47-39",
    "name": "Tarama"
  },
  {
    "code": "JP-21-25",
    "name": "Tarui"
  },
  {
    "code": "JP-46-08",
    "name": "Tarumizu"
  },
  {
    "code": "JP-10-07",
    "name": "Tatebayashi"
  },
  {
    "code": "JP-20-28",
    "name": "Tateshina"
  },
  {
    "code": "JP-16-13",
    "name": "Tateyama"
  },
  {
    "code": "JP-12-05",
    "name": "Tateyama"
  },
  {
    "code": "JP-46-36",
    "name": "Tatsugo"
  },
  {
    "code": "JP-28-29",
    "name": "Tatsuno"
  },
  {
    "code": "JP-20-34",
    "name": "Tatsuno"
  },
  {
    "code": "JP-29-20",
    "name": "Tawaramoto"
  },
  {
    "code": "JP-06-10",
    "name": "Tendo"
  },
  {
    "code": "JP-07-19",
    "name": "Tenei"
  },
  {
    "code": "JP-29-33",
    "name": "Tenkawa"
  },
  {
    "code": "JP-29-04",
    "name": "Tenri"
  },
  {
    "code": "JP-20-48",
    "name": "Tenryu"
  },
  {
    "code": "JP-01-173",
    "name": "Teshikaga"
  },
  {
    "code": "JP-01-112",
    "name": "Teshio"
  },
  {
    "code": "JP-24-10",
    "name": "Toba"
  },
  {
    "code": "JP-38-15",
    "name": "Tobe"
  },
  {
    "code": "JP-01-36",
    "name": "Tobetsu"
  },
  {
    "code": "JP-23-45",
    "name": "Tobishima"
  },
  {
    "code": "JP-09-03",
    "name": "Tochigi"
  },
  {
    "code": "JP-11-21",
    "name": "Toda"
  },
  {
    "code": "JP-23-53",
    "name": "Toei"
  },
  {
    "code": "JP-12-12",
    "name": "Togane"
  },
  {
    "code": "JP-42-15",
    "name": "Togitsu"
  },
  {
    "code": "JP-23-38",
    "name": "Togo"
  },
  {
    "code": "JP-40-45",
    "name": "Toho"
  },
  {
    "code": "JP-02-28",
    "name": "Tohoku"
  },
  {
    "code": "JP-24-16",
    "name": "Toin"
  },
  {
    "code": "JP-08-36",
    "name": "Tokai"
  },
  {
    "code": "JP-23-22",
    "name": "Tokai"
  },
  {
    "code": "JP-15-08",
    "name": "Tokamachi"
  },
  {
    "code": "JP-47-29",
    "name": "Tokashiki"
  },
  {
    "code": "JP-21-12",
    "name": "Toki"
  },
  {
    "code": "JP-11-50",
    "name": "Tokigawa"
  },
  {
    "code": "JP-23-17",
    "name": "Tokoname"
  },
  {
    "code": "JP-11-07",
    "name": "Tokorozawa"
  },
  {
    "code": "JP-46-38",
    "name": "Tokunoshima"
  },
  {
    "code": "JP-36-01",
    "name": "Tokushima"
  },
  {
    "code": "JP-01-89",
    "name": "Toma"
  },
  {
    "code": "JP-01-13",
    "name": "Tomakomai"
  },
  {
    "code": "JP-01-108",
    "name": "Tomamae"
  },
  {
    "code": "JP-01-66",
    "name": "Tomari"
  },
  {
    "code": "JP-04-10",
    "name": "Tome"
  },
  {
    "code": "JP-20-18",
    "name": "Tomi"
  },
  {
    "code": "JP-47-08",
    "name": "Tomigusuku"
  },
  {
    "code": "JP-21-35",
    "name": "Tomika"
  },
  {
    "code": "JP-07-52",
    "name": "Tomioka"
  },
  {
    "code": "JP-10-10",
    "name": "Tomioka"
  },
  {
    "code": "JP-12-31",
    "name": "Tomisato"
  },
  {
    "code": "JP-04-28",
    "name": "Tomiya"
  },
  {
    "code": "JP-47-32",
    "name": "Tonaki"
  },
  {
    "code": "JP-16-07",
    "name": "Tonami"
  },
  {
    "code": "JP-27-15",
    "name": "Tondabayashi"
  },
  {
    "code": "JP-08-44",
    "name": "Tone"
  },
  {
    "code": "JP-03-07",
    "name": "Tono"
  },
  {
    "code": "JP-37-09",
    "name": "Tonosho"
  },
  {
    "code": "JP-12-41",
    "name": "Tonosho"
  },
  {
    "code": "JP-38-11",
    "name": "Toon"
  },
  {
    "code": "JP-08-14",
    "name": "Toride"
  },
  {
    "code": "JP-39-21",
    "name": "Tosa"
  },
  {
    "code": "JP-39-05",
    "name": "Tosa"
  },
  {
    "code": "JP-39-08",
    "name": "Tosashimizu"
  },
  {
    "code": "JP-13-55",
    "name": "Toshima"
  },
  {
    "code": "JP-46-21",
    "name": "Toshima"
  },
  {
    "code": "JP-13-16",
    "name": "Toshima City"
  },
  {
    "code": "JP-41-03",
    "name": "Tosu"
  },
  {
    "code": "JP-29-35",
    "name": "Totsukawa"
  },
  {
    "code": "JP-31-01",
    "name": "Tottori"
  },
  {
    "code": "JP-02-06",
    "name": "Towada"
  },
  {
    "code": "JP-01-141",
    "name": "Toyako"
  },
  {
    "code": "JP-16-01",
    "name": "Toyama"
  },
  {
    "code": "JP-39-12",
    "name": "Toyo"
  },
  {
    "code": "JP-23-29",
    "name": "Toyoake"
  },
  {
    "code": "JP-23-02",
    "name": "Toyohashi"
  },
  {
    "code": "JP-23-08",
    "name": "Toyokawa"
  },
  {
    "code": "JP-01-164",
    "name": "Toyokoro"
  },
  {
    "code": "JP-27-04",
    "name": "Toyonaka"
  },
  {
    "code": "JP-23-54",
    "name": "Toyone"
  },
  {
    "code": "JP-27-35",
    "name": "Toyono"
  },
  {
    "code": "JP-28-10",
    "name": "Toyooka"
  },
  {
    "code": "JP-20-51",
    "name": "Toyooka"
  },
  {
    "code": "JP-25-17",
    "name": "Toyosato"
  },
  {
    "code": "JP-23-12",
    "name": "Toyota"
  },
  {
    "code": "JP-01-117",
    "name": "Toyotomi"
  },
  {
    "code": "JP-01-137",
    "name": "Toyoura"
  },
  {
    "code": "JP-23-40",
    "name": "Toyoyama"
  },
  {
    "code": "JP-06-27",
    "name": "Tozawa"
  },
  {
    "code": "JP-24-01",
    "name": "Tsu"
  },
  {
    "code": "JP-15-11",
    "name": "Tsubame"
  },
  {
    "code": "JP-17-13",
    "name": "Tsubata"
  },
  {
    "code": "JP-01-123",
    "name": "Tsubetsu"
  },
  {
    "code": "JP-08-03",
    "name": "Tsuchiura"
  },
  {
    "code": "JP-02-09",
    "name": "Tsugaru"
  },
  {
    "code": "JP-01-79",
    "name": "Tsukigata"
  },
  {
    "code": "JP-08-16",
    "name": "Tsukuba"
  },
  {
    "code": "JP-08-31",
    "name": "Tsukubamirai"
  },
  {
    "code": "JP-44-07",
    "name": "Tsukumi"
  },
  {
    "code": "JP-10-22",
    "name": "Tsumagoi"
  },
  {
    "code": "JP-43-35",
    "name": "Tsunagi"
  },
  {
    "code": "JP-15-27",
    "name": "Tsunan"
  },
  {
    "code": "JP-45-19",
    "name": "Tsuno"
  },
  {
    "code": "JP-39-30",
    "name": "Tsuno"
  },
  {
    "code": "JP-19-03",
    "name": "Tsuru"
  },
  {
    "code": "JP-18-02",
    "name": "Tsuruga"
  },
  {
    "code": "JP-11-36",
    "name": "Tsurugashima"
  },
  {
    "code": "JP-36-23",
    "name": "Tsurugi"
  },
  {
    "code": "JP-01-174",
    "name": "Tsurui"
  },
  {
    "code": "JP-06-03",
    "name": "Tsuruoka"
  },
  {
    "code": "JP-02-22",
    "name": "Tsuruta"
  },
  {
    "code": "JP-23-09",
    "name": "Tsushima"
  },
  {
    "code": "JP-42-08",
    "name": "Tsushima"
  },
  {
    "code": "JP-32-14",
    "name": "Tsuwano"
  },
  {
    "code": "JP-33-03",
    "name": "Tsuyama"
  },
  {
    "code": "JP-35-02",
    "name": "Ube"
  },
  {
    "code": "JP-43-24",
    "name": "Ubuyama"
  },
  {
    "code": "JP-38-16",
    "name": "Uchiko"
  },
  {
    "code": "JP-17-14",
    "name": "Uchinada"
  },
  {
    "code": "JP-29-12",
    "name": "Uda"
  },
  {
    "code": "JP-20-03",
    "name": "Ueda"
  },
  {
    "code": "JP-10-15",
    "name": "Ueno"
  },
  {
    "code": "JP-19-11",
    "name": "Uenohara"
  },
  {
    "code": "JP-05-24",
    "name": "Ugo"
  },
  {
    "code": "JP-26-05",
    "name": "Uji"
  },
  {
    "code": "JP-26-19",
    "name": "Ujitawara"
  },
  {
    "code": "JP-46-34",
    "name": "Uken"
  },
  {
    "code": "JP-43-11",
    "name": "Uki"
  },
  {
    "code": "JP-40-23",
    "name": "Ukiha"
  },
  {
    "code": "JP-39-17",
    "name": "Umaji"
  },
  {
    "code": "JP-40-30",
    "name": "Umi"
  },
  {
    "code": "JP-32-08",
    "name": "Unnan"
  },
  {
    "code": "JP-42-12",
    "name": "Unzen"
  },
  {
    "code": "JP-15-18",
    "name": "Uonuma"
  },
  {
    "code": "JP-16-03",
    "name": "Uozu"
  },
  {
    "code": "JP-01-168",
    "name": "Urahoro"
  },
  {
    "code": "JP-01-147",
    "name": "Urakawa"
  },
  {
    "code": "JP-47-04",
    "name": "Urasoe"
  },
  {
    "code": "JP-01-80",
    "name": "Urausu"
  },
  {
    "code": "JP-12-25",
    "name": "Urayasu"
  },
  {
    "code": "JP-41-09",
    "name": "Ureshino"
  },
  {
    "code": "JP-20-47",
    "name": "Urugi"
  },
  {
    "code": "JP-47-09",
    "name": "Uruma"
  },
  {
    "code": "JP-01-84",
    "name": "Uryu"
  },
  {
    "code": "JP-44-11",
    "name": "Usa"
  },
  {
    "code": "JP-08-15",
    "name": "Ushiku"
  },
  {
    "code": "JP-44-06",
    "name": "Usuki"
  },
  {
    "code": "JP-01-27",
    "name": "Utashinai"
  },
  {
    "code": "JP-37-13",
    "name": "Utazu"
  },
  {
    "code": "JP-43-09",
    "name": "Uto"
  },
  {
    "code": "JP-09-01",
    "name": "Utsunomiya"
  },
  {
    "code": "JP-38-03",
    "name": "Uwajima"
  },
  {
    "code": "JP-46-41",
    "name": "Wadomari"
  },
  {
    "code": "JP-17-04",
    "name": "Wajima"
  },
  {
    "code": "JP-31-06",
    "name": "Wakasa"
  },
  {
    "code": "JP-18-17",
    "name": "Wakasa"
  },
  {
    "code": "JP-30-01",
    "name": "Wakayama"
  },
  {
    "code": "JP-33-16",
    "name": "Wake"
  },
  {
    "code": "JP-35-15",
    "name": "Waki"
  },
  {
    "code": "JP-01-14",
    "name": "Wakkanai"
  },
  {
    "code": "JP-11-25",
    "name": "Wako"
  },
  {
    "code": "JP-04-32",
    "name": "Wakuya"
  },
  {
    "code": "JP-21-28",
    "name": "Wanochi"
  },
  {
    "code": "JP-11-20",
    "name": "Warabi"
  },
  {
    "code": "JP-01-99",
    "name": "Wassamu"
  },
  {
    "code": "JP-24-24",
    "name": "Watarai"
  },
  {
    "code": "JP-04-21",
    "name": "Watari"
  },
  {
    "code": "JP-26-21",
    "name": "Wazuka"
  },
  {
    "code": "JP-28-22",
    "name": "Yabu"
  },
  {
    "code": "JP-07-38",
    "name": "Yabuki"
  },
  {
    "code": "JP-12-28",
    "name": "Yachimata"
  },
  {
    "code": "JP-08-41",
    "name": "Yachiyo"
  },
  {
    "code": "JP-12-19",
    "name": "Yachiyo"
  },
  {
    "code": "JP-47-38",
    "name": "Yaese"
  },
  {
    "code": "JP-03-19",
    "name": "Yahaba"
  },
  {
    "code": "JP-15-22",
    "name": "Yahiko"
  },
  {
    "code": "JP-09-10",
    "name": "Yaita"
  },
  {
    "code": "JP-22-11",
    "name": "Yaizu"
  },
  {
    "code": "JP-33-19",
    "name": "Yakage"
  },
  {
    "code": "JP-01-45",
    "name": "Yakumo"
  },
  {
    "code": "JP-46-32",
    "name": "Yakushima"
  },
  {
    "code": "JP-03-25",
    "name": "Yamada"
  },
  {
    "code": "JP-43-42",
    "name": "Yamae"
  },
  {
    "code": "JP-43-07",
    "name": "Yamaga"
  },
  {
    "code": "JP-21-15",
    "name": "Yamagata"
  },
  {
    "code": "JP-20-61",
    "name": "Yamagata"
  },
  {
    "code": "JP-06-01",
    "name": "Yamagata"
  },
  {
    "code": "JP-35-03",
    "name": "Yamaguchi"
  },
  {
    "code": "JP-14-27",
    "name": "Yamakita"
  },
  {
    "code": "JP-04-22",
    "name": "Yamamoto"
  },
  {
    "code": "JP-19-23",
    "name": "Yamanakako"
  },
  {
    "code": "JP-19-04",
    "name": "Yamanashi"
  },
  {
    "code": "JP-06-14",
    "name": "Yamanobe"
  },
  {
    "code": "JP-20-71",
    "name": "Yamanochi"
  },
  {
    "code": "JP-43-32",
    "name": "Yamato"
  },
  {
    "code": "JP-14-14",
    "name": "Yamato"
  },
  {
    "code": "JP-46-33",
    "name": "Yamato"
  },
  {
    "code": "JP-29-03",
    "name": "Yamatokoriyama"
  },
  {
    "code": "JP-29-02",
    "name": "Yamatotakada"
  },
  {
    "code": "JP-07-40",
    "name": "Yamatsuri"
  },
  {
    "code": "JP-29-13",
    "name": "Yamazoe"
  },
  {
    "code": "JP-40-09",
    "name": "Yame"
  },
  {
    "code": "JP-40-08",
    "name": "Yanagawa"
  },
  {
    "code": "JP-35-10",
    "name": "Yanai"
  },
  {
    "code": "JP-07-30",
    "name": "Yanaizu"
  },
  {
    "code": "JP-27-13",
    "name": "Yao"
  },
  {
    "code": "JP-21-38",
    "name": "Yaotsu"
  },
  {
    "code": "JP-11-30",
    "name": "Yashio"
  },
  {
    "code": "JP-25-09",
    "name": "Yasu"
  },
  {
    "code": "JP-39-15",
    "name": "Yasuda"
  },
  {
    "code": "JP-32-06",
    "name": "Yasugi"
  },
  {
    "code": "JP-20-49",
    "name": "Yasuoka"
  },
  {
    "code": "JP-23-35",
    "name": "Yatomi"
  },
  {
    "code": "JP-43-02",
    "name": "Yatsushiro"
  },
  {
    "code": "JP-26-11",
    "name": "Yawata"
  },
  {
    "code": "JP-38-04",
    "name": "Yawatahama"
  },
  {
    "code": "JP-31-08",
    "name": "Yazu"
  },
  {
    "code": "JP-01-71",
    "name": "Yoichi"
  },
  {
    "code": "JP-24-02",
    "name": "Yokkaichi"
  },
  {
    "code": "JP-02-27",
    "name": "Yokohama"
  },
  {
    "code": "JP-14-01",
    "name": "Yokohama"
  },
  {
    "code": "JP-12-45",
    "name": "Yokoshibahikari"
  },
  {
    "code": "JP-14-04",
    "name": "Yokosuka"
  },
  {
    "code": "JP-05-03",
    "name": "Yokote"
  },
  {
    "code": "JP-11-51",
    "name": "Yokoze"
  },
  {
    "code": "JP-47-21",
    "name": "Yomitan"
  },
  {
    "code": "JP-02-13",
    "name": "Yomogita"
  },
  {
    "code": "JP-47-27",
    "name": "Yonabaru"
  },
  {
    "code": "JP-31-02",
    "name": "Yonago"
  },
  {
    "code": "JP-47-41",
    "name": "Yonaguni"
  },
  {
    "code": "JP-06-02",
    "name": "Yonezawa"
  },
  {
    "code": "JP-11-59",
    "name": "Yorii"
  },
  {
    "code": "JP-21-24",
    "name": "Yoro"
  },
  {
    "code": "JP-46-43",
    "name": "Yoron"
  },
  {
    "code": "JP-26-26",
    "name": "Yosano"
  },
  {
    "code": "JP-22-33",
    "name": "Yoshida"
  },
  {
    "code": "JP-32-15",
    "name": "Yoshika"
  },
  {
    "code": "JP-11-38",
    "name": "Yoshikawa"
  },
  {
    "code": "JP-11-48",
    "name": "Yoshimi"
  },
  {
    "code": "JP-29-29",
    "name": "Yoshino"
  },
  {
    "code": "JP-41-11",
    "name": "Yoshinogari"
  },
  {
    "code": "JP-36-05",
    "name": "Yoshinogawa"
  },
  {
    "code": "JP-10-14",
    "name": "Yoshioka"
  },
  {
    "code": "JP-40-58",
    "name": "Yoshitomi"
  },
  {
    "code": "JP-12-26",
    "name": "Yotsukaido"
  },
  {
    "code": "JP-30-14",
    "name": "Yuasa"
  },
  {
    "code": "JP-01-09",
    "name": "Yubari"
  },
  {
    "code": "JP-01-131",
    "name": "Yubetsu"
  },
  {
    "code": "JP-44-13",
    "name": "Yufu"
  },
  {
    "code": "JP-07-29",
    "name": "Yugawa"
  },
  {
    "code": "JP-14-31",
    "name": "Yugawara"
  },
  {
    "code": "JP-08-06",
    "name": "Yuki"
  },
  {
    "code": "JP-40-12",
    "name": "Yukuhashi"
  },
  {
    "code": "JP-01-76",
    "name": "Yuni"
  },
  {
    "code": "JP-43-38",
    "name": "Yunomae"
  },
  {
    "code": "JP-30-19",
    "name": "Yura"
  },
  {
    "code": "JP-31-10",
    "name": "Yurihama"
  },
  {
    "code": "JP-05-08",
    "name": "Yurihonjo"
  },
  {
    "code": "JP-39-28",
    "name": "Yusuhara"
  },
  {
    "code": "JP-46-24",
    "name": "Yusui"
  },
  {
    "code": "JP-06-35",
    "name": "Yuza"
  },
  {
    "code": "JP-05-06",
    "name": "Yuzawa"
  },
  {
    "code": "JP-15-26",
    "name": "Yuzawa"
  },
  {
    "code": "JP-14-17",
    "name": "Zama"
  },
  {
    "code": "JP-47-30",
    "name": "Zamami"
  },
  {
    "code": "JP-04-14",
    "name": "Zao"
  },
  {
    "code": "JP-37-04",
    "name": "Zentsuji"
  },
  {
    "code": "JP-14-10",
    "name": "Zushi"
  }
]